import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { Table, Form, Button, Spinner, Row, Col } from "react-bootstrap";
import BarLoader from "react-spinners/ClipLoader";
import { useSelector, useDispatch } from "react-redux";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { WysiwygEditor } from "../../../../Reuseable/WysiwygEditor";
import { Activity } from "../Activity";
import TrackingModalView from "../style";
import { api } from "../../../../../Services/api";
import {
  setAllTrackings,
  setMyTrackings,
} from "../../../../../redux/Tracking/actionCreator";
import EditIcon from "../../../../../../src/assets/images/icons/noun-edit-3556018.svg";
import CopyIcon from "../../../../../../src/assets/images/icons/copy.svg";
import usePrevious from "../../../../../Hooks/usePrevious";
import FormWrap from "../../../../Reuseable/FileUploader/styles";
import IconButton from "@mui/material/IconButton";
import DownloadIcon from "@mui/icons-material/Download";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import Iframe from "react-iframe";
import Alert from "@mui/material/Alert";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import TrackingViewWrap from "./style";
import ModalImage from "react-modal-image";
import DeleteIcon from "@mui/icons-material/Delete";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import useDownloader from "react-use-downloader";
import UIModal from "../../../../Reuseable/Modal";
import { useFetch } from "../../../../../Hooks/useFetch";
import { key } from "../../../../../data/queryKeys";
import moment from "moment";
import { client } from "../../../../..";
import {
  fileToBase64,
  toBase64,
} from "../../../../../Utilities/commonFunctions";
import Tooltip from "@mui/material/Tooltip";
import { DatePicker, message } from "antd";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

export const TrackingView = ({
  fetchFilteredTasks = () => {},
  allWorkFlow,
  isModalView,
  setTaskview,
  item,
  setTrackingItemData,
  fileLoading,
  setTaskFileType,
  setTaskFileList,
  taskfileType,
  taskfileList,
  taskfile,
  setTaskFile,
  data,
  setViewTaskData,
  showEditTask,
  setShowEditTask,
  setShowClone,
  updatedData,
  setUpdatedData,
  history,
  setHistory,
  type,
  name,
  value,
  setDeleteConfirmationShow,
  deletePermission,
  editPermission,
  refreshfiles,
  backlogsPermission,
  menu,
  setApprovalMsg,
  handlePopUpclose,
  selected_menu, // <-- add selected_menu as a prop
}) => {
  console.log("editPermission", editPermission);
  const [tudFileList, setTUDFileList] = useState(item?.tudDocument);
  const authToken = useSelector((state) => state.Auth.authToken);
  const dispatch = useDispatch();
  const trackingClientId = useSelector(
    (state) => state.Auth.user.trackingclientid,
  );
  const allTrackingsList = useSelector((state) => state.Tracking.allTrackings);
  const myTrackingList = useSelector((state) => state.Tracking.myTrackings);
  const index = allTrackingsList.findIndex(
    (element) => element.trackingid === item.trackingid,
  );
  const myTaskIndex = myTrackingList.findIndex(
    (element) => element.trackingid === item.trackingid,
  );
  const [loading, setLoading] = useState(false);
  const [approved, setApproved] = useState(false);
  const [msg, setMsg] = useState();
  const [fileloading, setfileLoading] = useState(false);
  const [FileLoading, setFileLoading] = useState(false);
  const [FileLoadingTUD, setFileLoadingTUD] = useState(false);
  const [showAddBtn, setShowAddBtn] = useState(false);
  const [showAddBtnTud, setShowAddBtnTud] = useState(false);
  const [showSaveBtn, setShowSaveBtn] = useState(false);
  const [selectedFile, setSelectedFile] = useState("");
  const [selectedTUDFile, setSelectedTUDFile] = useState("");
  const [FileUrl, setlFileUrl] = useState([]);
  const [tudFileUrl, setTUDFileUrl] = useState([]);
  const [deletedFile, setDeletedFile] = useState([]);
  const [dragActive, setDragActive] = useState(false);
  const [dragActivetud, setDragActivetud] = useState(false);
  const [fileType, setFileType] = useState([]);
  const [fname, setFName] = useState([]);
  const [fileUploadMessage, setFileUploadMessage] = useState(false);
  const [fileUploadMessageTUD, setFileUploadMessageTUD] = useState(false);
  const inputRef = useRef(null);
  const [tudDragActive, setTudDragActive] = useState(false);
  const tudInputRef = useRef(null);
  const [textCopyMsg, setTextCopyMsg] = useState();
  const [fileSize, setFileSize] = useState("");
  const [taskfilesize, setTaskFilesize] = useState("");
  const [currentFilename, setCurrentFilename] = useState("");
  const [downloading, setDownloading] = useState(false);
  const { percentage, download, isInProgress } = useDownloader();
  const [selectedRadioValue, setSelectedRadioValue] = useState("No");
  const [fileBlob, setFileBlob] = useState([]);
  const [tudFileType, setTudFileType] = useState([]);
  const [tudFName, setTudFName] = useState([]);
  const [tudFileSize, setTudFileSize] = useState([]);
  const [showTudAddBtn, setShowTudAddBtn] = useState(false);

  const [flagDescription, setFlagDescription] = useState("");
  const [flagModal, setFlagModal] = useState(false);
  const handleCloseFlagModal = () => setFlagModal(false);
  const titleRef = useRef();
  const descriptionRef = useRef();
  const isFinished = useRef(false);
  const userid = useSelector((state) => state.Auth.user.trackinguserid);
  const [testCaseFileList, setTestCaseFileList] = useState(
    item?.testCaseDocument || [],
  );
  const [selectedTestCaseFile, setSelectedTestCaseFile] = useState([]);
  const [testCaseFileUrl, setTestCaseFileUrl] = useState([]);
  const [testCaseFileType, setTestCaseFileType] = useState([]);
  const [testCaseFName, setTestCaseFName] = useState([]);
  const [testCaseFileSize, setTestCaseFileSize] = useState([]);
  const [showAddBtnTestCase, setShowAddBtnTestCase] = useState(false);
  const [fileUploadMessageTestCase, setFileUploadMessageTestCase] =
    useState(false);
  const [fileLoadingTestCase, setFileLoadingTestCase] = useState(false);
  const testCaseInputRef = useRef(null);
  const [testCaseDragActive, setTestCaseDragActive] = useState(false);
  const [iseditItem, setIseditItem] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);

  const originalDeadline = item.deadline ? dayjs(item.deadline) : null;
  const userRole = "Developer";

  const originalDate = dayjs(originalDeadline);

  const [deadline, setDeadline] = useState(originalDate);

  console.log("originalDate", dayjs(deadline).format("YYYY-MM-DD"));

  const getMaxWorkingDate = (startDate, days) => {
    let date = dayjs(startDate);
    let count = 0;

    for (let i = 0; i < 10; i++) {
      date = date.add(1, "day");

      const day = date.day();

      if (day !== 0 && day !== 6) {
        count++;
      }

      if (count === days) break;
    }

    return date;
  };

  const maxDate = getMaxWorkingDate(originalDate, 5);

  const disabledDate = (current) => {
    if (userRole === "ProductOwner") return false;

    return (
      current.isBefore(originalDate, "day") ||
      current.isAfter(maxDate, "day") ||
      current.day() === 0 ||
      current.day() === 6
    );
  };

  // const canEditDeadline = (deadline, role) => {
  //   const today = dayjs();
  //   const originalDate = dayjs(deadline);
  //   const diffDays = today.diff(originalDate, "day");
  //   console.log(diffDays, "diffDaysdiffDays", originalDate);

  //   if (diffDays <= 5) return true;
  //   if (role === "ProductOwner") return true;

  //   return false;
  // };

  const handleTestCaseChange = (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;
    const invalid = files.some((f) => {
      const ext = (f?.name || "").split(".").pop().split("?")[0].toLowerCase();
      return !["doc", "docx"].includes(ext);
    });
    if (invalid) {
      message.error(
        "Only .doc and .docx files are allowed for Test Case files",
      );
      e.target.value = "";
      return;
    }
    setShowAddBtnTestCase(true);
    files.forEach((file) => {
      setSelectedTestCaseFile((prev) => [...prev, file]);
      setTestCaseFName((prev) => [...prev, file.name]);
      setTestCaseFileType((prev) => [...prev, file.name.split(".").pop()]);
      setTestCaseFileSize((prev) => [...prev, file.size]);
    });
  };

  const handleTestCaseDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setTestCaseDragActive(false);
    const files = Array.from(e.dataTransfer.files || []);
    if (files.length === 0) return;
    const invalid = files.some((f) => {
      const ext = (f?.name || "").split(".").pop().split("?")[0].toLowerCase();
      return !["doc", "docx"].includes(ext);
    });
    if (invalid) {
      message.error(
        "Only .doc and .docx files are allowed for Test Case files",
      );
      return;
    }
    files.forEach((file) => {
      setSelectedTestCaseFile((prev) => [...prev, file]);
      setTestCaseFName((prev) => [...prev, file.name]);
      setTestCaseFileType((prev) => [...prev, file.name.split(".").pop()]);
      setTestCaseFileSize((prev) => [...prev, file.size]);
    });
    setShowAddBtnTestCase(true);
  };

  const handleRemoveTUD = async (trackingid, index) => {
    try {
      // Get the file to be removed
      const removedFile = tudFileList[index];

      // Remove the file locally
      const updatedFiles = tudFileList.filter((_, i) => i !== index);
      setTUDFileList(updatedFiles);

      // Prepare payload for backend update
      const Obj = {
        name: "tudfile",
        tudDocument: updatedFiles,
      };

      // Update the record in the backend
      await api.patch(`/tracking/update/${trackingid}`, Obj, {
        headers: {
          authorizationtoken: `${authToken}`,
        },
      });

      console.log("TUD file removed successfully.");
    } catch (error) {
      console.error("Error removing TUD file:", error);
    }
  };

  const handleRemoveTestCase = async (trackingid, index) => {
    try {
      // Get the file to be removed
      const removedFile = testCaseFileList[index];

      // Remove the file locally
      const updatedFiles = testCaseFileList.filter((_, i) => i !== index);
      setTestCaseFileList(updatedFiles);

      // Prepare payload for backend update
      const Obj = {
        name: "testcasefile",
        testCaseDocument: updatedFiles,
      };

      // Update the record in the backend
      await api.patch(`/tracking/update/${trackingid}`, Obj, {
        headers: {
          authorizationtoken: `${authToken}`,
        },
      });

      console.log("Test case file removed successfully.");
    } catch (error) {
      console.error("Error removing test case file:", error);
    }
  };

  const handleUploadFileTestCase = async (trackingid, projectid) => {
    setFileUploadMessageTestCase(null);
    setFileLoadingTestCase(true);

    const updatedFile = selectedTestCaseFile.map((file, index) => ({
      file: file,
      id: new Date().getTime() + index,
      name: file.name,
      type: file.type,
      subname:
        "TCD-" +
        projectid +
        "-" +
        trackingid +
        "-" +
        moment().format("DD-MM-YYYY HH:mm"),
    }));

    try {
      const uploadPromises = updatedFile.map(async (fileData) => {
        const response = await api.post(
          `/tracking/document/${trackingClientId}?method=upload`,
          {
            tcddocumentid: fileData.id,
            filename: fileData.name,
            name: "testcasefile",
          },
          { headers: { authorizationtoken: `${authToken}` } },
        );

        const URL = response.data?.data;
        await fetch(URL, {
          method: "PUT",
          headers: {
            "Content-Type": fileData.type || "application/octet-stream",
          },
          body: fileData.file,
        });
      });

      await Promise.all(uploadPromises);

      const value = updatedFile?.map((item) => ({
        testcasedocumentid: item.id,
        filename: item.name,
        subname: item?.subname,
      }));

      let Obj = {
        name: "testcasefile",
        testCaseDocument: [...(testCaseFileList || []), ...value],
      };

      api
        .patch(`/tracking/update/${trackingid}`, Obj, {
          headers: { authorizationtoken: `${authToken}` },
        })
        .then((response) => {
          if (response.data?.status) {
            setShowAddBtnTestCase(false);
            setTimeout(() => {
              setFileUploadMessageTestCase("");
            }, 3000);
            setFileUploadMessageTestCase(
              "Test Case File Uploaded Successfully",
            );
            setFileLoadingTestCase(false);
            setTestCaseFileList([...(testCaseFileList || []), ...value]);
            setSelectedTestCaseFile("");
          }
        });
    } catch (error) {
      console.log("Error uploading Test Case files:", error);
      setFileLoadingTestCase(false);
    }
  };

  const { data: allTasksTypesRes } = useFetch(
    key.get_all_tasktypes,
    "/trackingtasktype",
    () => {},
    () => {},
    false,
    false,
  );
  let allTaskTypes = allTasksTypesRes?.data ?? [];

  const getTaskTypeOptions = () => {
    const priorityLabel = data?.priority;
    if (
      priorityLabel?.toLowerCase() === "blocker1" ||
      priorityLabel?.toLowerCase() === "blocker2"
    ) {
      // Only show Bug and Issues
      return allTaskTypes.filter(
        (item) =>
          item.label === "Bug/Issue" ||
          item.label?.toLowerCase() === "bug/issues",
      );
    }
    // Show all options otherwise
    return allTaskTypes;
  };

  const taskTypeOptions = useMemo(() => getTaskTypeOptions(), [data?.priority]);
  const { data: allBacklogsRes } = useFetch(
    key.get_backlogs_data,
    `/backloglist/${trackingClientId}`,
    () => {},
    () => {},
    false,
    true,
  );

  let allBacklogs = allBacklogsRes?.data ?? [];

  const { data: allProjectsRes } = useFetch(
    key.get_all_projects,
    `/trackingprojects/${trackingClientId}`,
    () => {},
    () => {},
    false,
    false,
  );
  let allProjectsData = allProjectsRes?.data?.Items ?? [];

  const { data: allMembersRes } = useFetch(
    key.get_all_members,
    `/trackingusers/memberlist/${trackingClientId}`,
    () => {},
    () => {},
    false,
    false,
  );

  let allMembers = allMembersRes?.data ?? [];
  console.log("allMembers-->", allMembers);

  // Add state for priorities
  const [rawPriorities, setRawPriorities] = useState([]);
  const [priorityOptions, setPriorityOptions] = useState([]);
  {
    console.log("priorityOptions", priorityOptions);
  }

  const FlagOptions = [
    { label: "Flag 1", id: "1", value: "Flag 1" },
    { label: "Flag 2", id: "2", value: "Flag 2" },
    { label: "Flag 3", id: "3", value: "Flag 3" },
  ];
  // Fetch priorities on mount
  useEffect(() => {
    api
      .get(`/tracking/priority/${trackingClientId}`)
      .then((res) => {
        setRawPriorities(res.data.data);
      })
      .catch(() => setRawPriorities([]));
  }, [trackingClientId]);

  // Update priorityOptions when project changes or priorities are fetched
  useEffect(() => {
    if (!rawPriorities || !allProjectsData || !data.projectid) {
      setPriorityOptions([]);
      return;
    }
    // Find the project id for priorities
    let projectId = data.projectid;
    // Try to match by trackingprojectid or number
    let project = allProjectsData.find(
      (p) => p.trackingprojectid === projectId || p.number === projectId,
    );
    let projectPriority = rawPriorities.find(
      (p) => p.trackingprojectid === (project?.trackingprojectid || projectId),
    );
    if (projectPriority && Array.isArray(projectPriority.prioritydata)) {
      setPriorityOptions(
        projectPriority.prioritydata.map((p) => {
          let label = p.priority.trim().toLowerCase();

          if (label?.startsWith("blocker")) {
            // Extract number from blocker string (e.g., "blocker1" → 1)
            const level = label?.match(/\d+/)?.[0];
            label = level ? `Blocker Level ${level}` : "Blocker Level 1";
          } else {
            // Capitalize first letter for non-blocker labels
            label = label.charAt(0).toUpperCase() + label.slice(1);
          }

          return {
            label,
            id: p.priority.toLowerCase().replace(/\s+/g, ""),
          };
        }),
      );
    } else {
      setPriorityOptions([]);
    }
  }, [rawPriorities, allProjectsData, data.projectid]);

  let projectNameData = allProjectsData?.find((e) => {
    return (
      e.trackingprojectid === item.trackingprojectsid ||
      e.number == item.trackingprojectsid
    );
  });

  const closeFileupload = () => {
    setShowAddBtn(false);
    setTimeout(() => {
      setFileUploadMessage("");
    }, 3000);
  };
  useEffect(() => {
    if (isInProgress == false) {
      setDownloading(false);
    }
  }, [isInProgress]);

  useEffect(() => {
    setTaskFilesize(item.filesize);
  }, [item.filesize]);

  useEffect(() => {
    if (isFinished.current === false) {
      getFetchFileData(item);
      isFinished.current = true;
    }

    return () => {
      setShowEditTask("");
      resetImage();
      setHistory("");
    };
  }, []);

  useEffect(() => {
    if (allProjectsData && allProjectsData?.length > 0) {
      // This will trigger a re-render with the correct project name
    }
  }, [allProjectsData]);

  const getFetchFileData = (item) => {
    for (let i = 0; i < item.fileurls.length; i++) {
      setFileLoading(true);
      api
        .get(
          `/tracking/fileupload/${trackingClientId}/${item.trackingid}/${item?.fileurls[i]}`,
        )
        .then((response) => {
          if (response) {
            let Filename = item.fileurls[i];
            setTaskFile((prevfiles) => [...prevfiles, response.data.url]);
            setTaskFileType((prevfiles) => [
              ...prevfiles,
              Filename.split(".").pop(),
            ]);
            setTaskFileList((prevfiles) => [...prevfiles, Filename]);
            setFileLoading(false);
          }
        })
        .catch((error) => console.error("error-->", error));
    }
  };

  const onClickSave = () => setShowSaveBtn(true);
  const ConfirmDeleteFile = () => setShowSaveBtn(false);
  const previousData = usePrevious(data);
  let taskName = allTaskTypes?.find((e) => e.id == data?.taskType);
  if (taskName) taskName = taskName.label;

  // Get project name - prioritize from item data, then from projects data
  let projectName = item.project_name || item.projectName || item.projectname;

  if (!projectName) {
    // First try to find by item.trackingprojectsid (more reliable)
    projectName = allProjectsData?.find((e) => {
      return (
        e.trackingprojectid === item.trackingprojectsid ||
        e.number == item.trackingprojectsid
      );
    });
    if (projectName) {
      projectName = projectName.label;
    } else {
      // Fallback: try to find by data.projectid
      projectName = allProjectsData?.find((e) => {
        return (
          e.trackingprojectid === data?.projectid || e.number == data?.projectid
        );
      });
      if (projectName) {
        projectName = projectName.label;
      } else {
        projectName = "Not Assigned";
      }
    }
  }

  let newArr = [];
  item?.workflow?.forEach((e, i) => {
    Object.keys(e).map((n) => {
      newArr.push(e[n]);
    });
  });
  let result = [];

  if (newArr.length > 0) {
    newArr.forEach((item, i) => {
      result.push({ label: item, id: i });
    });
    if (data) data.status_list = result;
  } else {
    if (data) data.status_list = [{ label: "In approval", id: 0 }];
  }

  // let reportedByName = allMembers.find((e) => {
  //   console.log(e.userId, item?.reportedby , "itemrepssssortedby", e.userId === item?.reportedby);
  //   return e.userId?.trim() === item?.reportedby?.trim();
  // });

  let reportedByName = allMembers.find((e) => {
    const userId = e.userId?.trim().toLowerCase();
    const reportedBy = item?.reportedby?.trim().toLowerCase();

    console.log("", userId, "reportedByuserId", reportedBy);

    return userId === reportedBy;
  });
  console.log(item, "reportedsssByName", reportedByName);

  if (reportedByName) {
    reportedByName = reportedByName.personname;
  }

  let workflowName = result.find((e) => {
    return e.id === parseInt(data.status, 10);
  });
  if (workflowName) workflowName = workflowName.label;

  let results = [];
  let team_mates = allProjectsData?.find(
    (e) =>
      e.trackingprojectid === data?.projectid || e.number === data?.projectid,
  );

  let assignedToName = allMembers?.find(
    (e) => e.userId === (data?.assignedTo || data?.assignedto),
  );

  if (assignedToName) assignedToName = assignedToName.personname;

  if (team_mates) {
    team_mates = team_mates.teammates;
  }
  if (team_mates) {
    team_mates.forEach((element) => {
      results.push({ label: element.label, id: element.id });
    });
    allMembers = [...results, { label: "None", id: "notAssigned" }];
  } else {
    allMembers = [{ label: "None", id: "notAssigned" }];
  }

  console.log(showEditTask, "showEditTaskshowEditTask");

  const editItem = (item) => {
    if (item === "datepicker")
      setShowEditTask((prevState) => {
        return { ...prevState, editTitle: true };
      });
    if (item === "title")
      setShowEditTask((prevState) => {
        return { ...prevState, editTitle: true };
      });
    if (item === "project")
      setShowEditTask((prevState) => {
        return { ...prevState, editProject: true };
      });
    if (item === "task_type")
      setShowEditTask((prevState) => {
        return { ...prevState, editTaskType: true };
      });
    if (item === "assigned_to")
      setShowEditTask((prevState) => {
        return { ...prevState, editAssignedTo: true };
      });
    if (item === "priority")
      setShowEditTask((prevState) => {
        return { ...prevState, editPriority: true };
      });
    if (item === "timeline")
      setShowEditTask((prevState) => {
        return { ...prevState, editTimeline: true };
      });
    if (item === "status")
      setShowEditTask((prevState) => {
        return { ...prevState, editStatus: true };
      });
    if (item === "description")
      setShowEditTask((prevState) => {
        return { ...prevState, editDescription: true };
      });
    if (item === "fileurls")
      setShowEditTask((prevState) => {
        return { ...prevState, editfileurls: true };
      });
    if (item === "raiseflag")
      setShowEditTask((prevState) => {
        return { ...prevState, editraiseflag: true };
      });
  };

  useEffect(() => {
    if (showEditTask?.editTitle) {
      titleRef.current.focus();
    }
    if (showEditTask?.editDescription) {
      descriptionRef.current.focusEditor();
    }
  }, [showEditTask]);
  const handleRaiseFlag = async (e) => {
    try {
      const response = await api.post(
        `/raiseflag/${trackingClientId}`,
        {
          taskid: item.trackingid,
          raiseflag: [
            {
              flagetype: data.raiseflag?.[0]?.flagetype,
              flagid: data?.raiseflag?.[0]?.flagid,
              flagsendernemail: userid,
            },
          ],
        },
        {
          headers: {
            authorizationtoken: ` ${authToken}`,
          },
        },
      );
      if (response.status === 200) {
        setApprovalMsg("Flag raised successfully.");
      }
    } catch (err) {
      console.error("Error in handleRaiseFlag:", err);
    }
  };
  const [changedFlagVal, setChangedFlagVal] = useState({});
  // const updateTask = async (name, value) => {
  //   console.log("namevalue-->", name, value);
  //   if (name === "raiseflag") {
  //     await handleRaiseFlag(); // ✅ Wait for flag raising to finish
  //     // return;
  //   }
  //   console.log("value1121--->", value);
  //   setLoading(true);
  //   const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  //   const prioritySlaMapping = {
  //     blocker1: 4,
  //     blocker2: 8,
  //     major: 16,
  //     medium: 40,
  //     low: 80,
  //   };

  //   let Obj = {
  //     name: name,
  //     value: value,
  //     timezone: timezone,
  //     label: data?.status_list?.find((item) => item.id == value)?.label || "",
  //   };

  //   if (name === "priority" && value) {
  //     let selected = priorityOptions.find(
  //       (p) => p.id === value || p.label === value,
  //     );
  //     Obj.value = selected ? selected.id : value;

  //     const slaHours = prioritySlaMapping[Obj.value] || 0;
  //     Obj.sla = slaHours;

  //     Obj.deadline = moment()
  //       .add(slaHours, "hours")
  //       .utc()
  //       .format("YYYY-MM-DDTHH:mm:ss\\Z");
  //   } else if (name === "trackingprojectstatusid" && value) {
  //     let selected = (data.status_list || []).find(
  //       (s) => s.id == value || s.label === value,
  //     );
  //     Obj.value = selected ? selected.id : value;
  //   } else if (name === "assignedto" && value) {
  //     let selected = (allMembers || []).find(
  //       (m) => m.id == value || m.label === value,
  //     );
  //     Obj.value = selected ? selected.id : value;
  //     const priorityValue = data?.priority;
  //     const slaHours = prioritySlaMapping[priorityValue] || 0;
  //     Obj.sla = slaHours;
  //     Obj.deadline = moment()
  //       .add(slaHours, "hours")
  //       .utc()
  //       .format("YYYY-MM-DDTHH:mm:ss\\Z");
  //   } else if (name === "trackingprojectsid" && value) {
  //     let selected = (allProjectsData || []).find(
  //       (p) => p.trackingprojectid == value || p.label === value,
  //     );
  //     Obj.value = selected ? selected.trackingprojectid : value;
  //   } else if (name === "type" && value) {
  //     let selected = (allTaskTypes || []).find(
  //       (t) => t.id == value || t.label === value,
  //     );
  //     Obj.value = selected ? selected.id : value;
  //   }

  //   if (value === "3") {
  //     Obj.originaldeadline = moment();
  //     if (item.eta) {
  //       let etaMoment = moment(
  //         item.deadline,
  //         [
  //           moment.ISO_8601,
  //           "DD/MM/YYYY, hh:mm A",
  //           "YYYY-MM-DD HH:mm:ss",
  //           "MMM D, YYYY, hh:mm A",
  //           "MMM D, YYYY hh:mm A",
  //         ],
  //         true,
  //       );

  //       if (!etaMoment.isValid()) {
  //         const match = String(item.eta).match(
  //           /(\d+(?:\.\d+)?)\s*(hr|hour|hrs|hours)/i,
  //         );
  //         if (match) {
  //           const hours = parseFloat(match[1]);
  //           etaMoment = moment().add(hours, "hours");
  //         }
  //       }

  //       if (etaMoment.isValid()) {
  //         const now = moment();
  //         let diffMs = etaMoment.diff(now);
  //         let totalMinutes = Math.floor(Math.abs(diffMs) / (1000 * 60));
  //         let hours = Math.floor(totalMinutes / 60);
  //         let minutes = totalMinutes % 60;
  //         Obj.originalsla = `${hours}hrs${minutes > 0 ? " " + minutes + "mins" : ""}`;
  //       } else {
  //         Obj.originalsla = "";
  //       }
  //     } else {
  //       Obj.originalsla = "";
  //     }
  //   }

  //   if (name === "title") {
  //     setViewTaskData((prevState) => ({ ...prevState, title: value }));
  //   }
  //   if (name === "timeline") {
  //     setViewTaskData((prevState) => ({ ...prevState, timeline: value }));
  //   }

  //   if (value) {
  //     api
  //       .patch("/tracking/update/" + item.trackingid, Obj, {
  //         headers: { authorizationtoken: `${authToken}` },
  //       })
  //       .then(function (response) {
  //         setLoading(false);
  //         if (response.status === 200) {
  //           deletedFile.length > 0 && DeleteFile();
  //           setHistory(response.data.updatedHistory);

  //           if (index !== -1 || index === 0) {
  //             if (name === "raiseflag") {
  //               allTrackingsList[index][name] =
  //                 changedFlagVal.raiseflag || value;
  //             } else {
  //               allTrackingsList[index][name] = value;
  //             }
  //             allTrackingsList[index]["history"] = response.data.updatedHistory;
  //             dispatch(setAllTrackings([...allTrackingsList]));
  //           }

  //           if (myTaskIndex !== -1 || myTaskIndex === 0) {
  //             if (name === "raiseflag") {
  //               myTrackingList[myTaskIndex][name] =
  //                 changedFlagVal?.raiseflag || value;
  //             } else {
  //               myTrackingList[myTaskIndex][name] = value;
  //             }
  //             myTrackingList[myTaskIndex]["history"] =
  //               response.data.updatedHistory;
  //             dispatch(setMyTrackings([...myTrackingList]));
  //           }

  //           if (name === "description") {
  //             setViewTaskData((prevState) => ({
  //               ...prevState,
  //               description: value,
  //             }));
  //             setShowEditTask((prevState) => ({
  //               ...prevState,
  //               editDescription: false,
  //             }));
  //           }
  //           console.log(value, "valuevalue");

  //           if (value == 8) {
  //             handlePopUpclose();
  //           }

  //           api.get(`/tracking/priority/${trackingClientId}`).then((res) => {
  //             setRawPriorities(res.data.data);
  //           });

  //           if (name === "priority" && Obj.sla) {
  //             setUpdatedData((prev) => ({
  //               ...prev,
  //               sla: Obj.sla,
  //               deadline: Obj.deadline,
  //               eta: Obj.sla,
  //               expecteddeadline: Obj.deadline,
  //             }));
  //             if (item) {
  //               item.sla = Obj.sla;
  //               item.deadline = Obj.deadline;
  //               item.eta = Obj.sla;
  //               item.expecteddeadline = Obj.deadline;
  //             }
  //           }
  //         }
  //       })
  //       .catch((_error) => setLoading(false));
  //   }
  // };
  const updateTask = async (name, value) => {
    console.log(name, value, "namevaluessa", deadline);
    if (name === "raiseflag") {
      await handleRaiseFlag(); // ✅ Wait for flag raising to finish
      // return;
    }
    setLoading(true);

    if (name === "raiseflag") {
      await handleRaiseFlag(); // ✅ Wait for flag raising to finish
      // return;
    }
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const prioritySlaMapping = {
      blocker1: 4,
      blocker2: 8,
      major: 16,
      medium: 40,
      low: 80,
    };

    let Obj = {
      name: name,
      value: value,
      timezone: timezone,
      label: data?.status_list?.find((item) => item.id == value)?.label || "",
    };
    console.log(
      dayjs(deadline).format("YYYY-MM-DD"),
      Obj,
      "namevaluesss1",
      deadline,
    );

    if (name === "priority" && value) {
      let selected = priorityOptions.find(
        (p) => p.id === value || p.label === value,
      );
      Obj.value = selected ? selected.id : value;

      const slaHours = prioritySlaMapping[Obj.value] || 0;
      Obj.sla = slaHours;

      Obj.deadline = moment()
        .add(slaHours, "hours")
        .utc()
        .format("YYYY-MM-DDTHH:mm:ss\\Z");
      console.log("values5", Obj.deadline);
    } else if (name === "trackingprojectstatusid" && value) {
      let selected = (data.status_list || []).find(
        (s) => s.id == value || s.label === value,
      );
      Obj.value = selected ? selected.id : value;
    } else if (name === "assignedto" && value) {
      let selected = (allMembers || []).find(
        (m) => m.id == value || m.label === value,
      );
      Obj.value = selected ? selected.id : value;
      const priorityValue = data?.priority;
      const slaHours = prioritySlaMapping[priorityValue] || 0;
      Obj.sla = data?.eta;
      Obj.deadline = moment()
        .add(slaHours, "hours")
        .utc()
        .format("YYYY-MM-DDTHH:mm:ss\\Z");
      dayjs(deadline).format("YYYY-MM-DD");
    } else if (name === "trackingprojectsid" && value) {
      let selected = (allProjectsData || []).find(
        (p) => p.trackingprojectid == value || p.label === value,
      );
      Obj.value = selected ? selected.trackingprojectid : value;
    } else if (name === "type" && value) {
      let selected = (allTaskTypes || []).find(
        (t) => t.id == value || t.label === value,
      );
      Obj.value = selected ? selected.id : value;
    }
    console.log(
      dayjs(deadline).format("YYYY-MM-DD"),
      Obj,
      "namevaluesss2",
      deadline,
    );

    if (value === "3") {
      Obj.originaldeadline = moment();
      if (item.eta) {
        let etaMoment = moment(
          item.deadline,
          [
            moment.ISO_8601,
            "DD/MM/YYYY, hh:mm A",
            "YYYY-MM-DD HH:mm:ss",
            "MMM D, YYYY, hh:mm A",
            "MMM D, YYYY hh:mm A",
          ],
          true,
        );

        if (!etaMoment.isValid()) {
          const match = String(item.eta).match(
            /(\d+(?:\.\d+)?)\s*(hr|hour|hrs|hours)/i,
          );
          if (match) {
            const hours = parseFloat(match[1]);
            etaMoment = moment().add(hours, "hours");
          }
        }

        if (etaMoment.isValid()) {
          const now = moment();
          let diffMs = etaMoment.diff(now);
          let totalMinutes = Math.floor(Math.abs(diffMs) / (1000 * 60));
          let hours = Math.floor(totalMinutes / 60);
          let minutes = totalMinutes % 60;
          Obj.originalsla = `${hours}hrs${minutes > 0 ? " " + minutes + "mins" : ""}`;
        } else {
          Obj.originalsla = "";
        }
        console.log("valuesbajd", Obj.deadline);
      } else {
        Obj.originalsla = "";
      }
    }

    console.log(
      item?.workflowId === allWorkFlow?.workFlowId,
      "hdsjsswswjs",
      allWorkFlow[item?.workflowId]?.[0]?.defaultdeadline ===
        Number(item?.trackingprojectstatusid),
    );
    if (
      name === "trackingprojectstatusid" &&
      allWorkFlow[item?.workflowId]?.[0]?.defaultdeadline === Number(value)
    ) {
      Obj.ClosedTime = moment();
      if (item.eta) {
        let etaMoment = moment(
          item.deadline,
          [
            moment.ISO_8601,
            "DD/MM/YYYY, hh:mm A",
            "YYYY-MM-DD HH:mm:ss",
            "MMM D, YYYY, hh:mm A",
            "MMM D, YYYY hh:mm A",
          ],
          true,
        );

        if (!etaMoment.isValid()) {
          const match = String(item.eta).match(
            /(\d+(?:\.\d+)?)\s*(hr|hour|hrs|hours)/i,
          );
          if (match) {
            const hours = parseFloat(match[1]);
            etaMoment = moment().add(hours, "hours");
          }
        }

        if (etaMoment.isValid()) {
          const now = moment();
          let diffMs = etaMoment.diff(now);
          let totalMinutes = Math.floor(Math.abs(diffMs) / (1000 * 60));
          let hours = Math.floor(totalMinutes / 60);
          let minutes = totalMinutes % 60;
          Obj.originalsla = `${hours}hrs${
            minutes > 0 ? " " + minutes + "mins" : ""
          }`;
        } else {
          Obj.originalsla = "";
        }
      } else {
        Obj.originalsla = "";
      }
    }

    if (name === "title") {
      setViewTaskData((prevState) => ({ ...prevState, title: value }));
    }
    if (name === "timeline") {
      setViewTaskData((prevState) => ({ ...prevState, timeline: value }));
    }
    if (name === "deadline") {
      console.log(name, value, "namevaluessa", name === "deadline", deadline);

      Obj.deadline = value;
      // Obj.deadline = dayjs(value).toISOString();
      Obj.label = "";
      Obj.name = "priority";
      Obj.sla = item?.eta || 0;
      Obj.timezone = item?.timezone || timezone;
      Obj.value = item?.priority || "";
    }

    let count = 1;

    if (value) {
      api
        .patch("/tracking/update/" + item.trackingid, Obj, {
          headers: { authorizationtoken: `${authToken}` },
        })
        .then(function (response) {
          setLoading(false);
          fetchFilteredTasks(true);
          if (response.status === 200) {
            deletedFile.length > 0 && DeleteFile();
            setHistory(response.data.updatedHistory);

            if (index !== -1 || index === 0) {
              if (name === "raiseflag") {
                allTrackingsList[index][name] =
                  changedFlagVal.raiseflag || value;
              } else {
                allTrackingsList[index][name] = value;
              }
              allTrackingsList[index]["history"] = response.data.updatedHistory;
              dispatch(setAllTrackings([...allTrackingsList]));
            }

            if (myTaskIndex !== -1 || myTaskIndex === 0) {
              if (name === "raiseflag") {
                myTrackingList[myTaskIndex][name] =
                  changedFlagVal?.raiseflag || value;
              } else {
                myTrackingList[myTaskIndex][name] = value;
              }
              myTrackingList[myTaskIndex]["history"] =
                response.data.updatedHistory;
              dispatch(setMyTrackings([...myTrackingList]));
            }

            if (name === "description") {
              setViewTaskData((prevState) => ({
                ...prevState,
                description: value,
              }));
              setShowEditTask((prevState) => ({
                ...prevState,
                editDescription: false,
              }));
            }

            api.get(`/tracking/priority/${trackingClientId}`).then((res) => {
              setRawPriorities(res.data.data);
            });

            if (name === "priority" && Obj.sla) {
              setUpdatedData((prev) => ({
                ...prev,
                sla: Obj.sla,
                deadline: Obj.deadline,
                eta: Obj.sla,
                expecteddeadline: Obj.deadline,
              }));
              if (item) {
                item.sla = Obj.sla;
                item.deadline = Obj.deadline;
                item.eta = Obj.sla;
                item.expecteddeadline = Obj.deadline;
              }
            }
          }
        })
        .catch((_error) => setLoading(false));
    }
  };

  const editIconCSS = {
    marginLeft: "3%",
    cursor: "pointer",
    marginTop: "1%",
    marginRight: "10px",
  };

  const copyIconCSS = {
    marginLeft: "3%",
    cursor: "pointer",
    marginTop: "2%",
  };

  const tickCloseIconCSS = {
    fontSize: "17px",
    marginTop: "-2px",
    marginLeft: "1%",
  };

  const copyTicketNumber = (e) => {
    var text = trackingClientId + "-" + item.trackingid;
    navigator.clipboard.writeText(text);
    setMsg("Copied");
    setTimeout(() => {
      setMsg("");
    }, 750);
  };

  const copyText = (e) => {
    var text = data.title;
    navigator.clipboard.writeText(text);
    setTextCopyMsg("Copied");
    setTimeout(() => {
      setTextCopyMsg("");
    }, 750);
  };

  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(true);
  };

  const handleDragtud = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragActivetud(true);
  };

  const handleDragtestCase = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setTestCaseDragActive(true);
  };
  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    setSelectedFile((prevfiles) => [...prevfiles, e.dataTransfer.files[0]]);
    setFName((prevfiles) => [...prevfiles, e.dataTransfer.files[0].name]);
    setFileType((prevfiles) => [
      ...prevfiles,
      e.dataTransfer.files[0].name.split(".").pop(),
    ]);
    setFileSize((prevfiles) => [...prevfiles, e.dataTransfer.files[0].size]);
    setShowAddBtn(true);
  };

  const handleTudDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setTudDragActive(false);
    const files = Array.from(e.dataTransfer.files || []);
    if (files.length === 0) return;
    const invalid = files.some((f) => {
      const ext = (f?.name || "").split(".").pop().split("?")[0].toLowerCase();
      return !["doc", "docx"].includes(ext);
    });
    if (invalid) {
      message.error("Only .doc and .docx files are allowed for DOU files");
      return;
    }
    files.forEach((file) => {
      setSelectedTUDFile((prev) => [...prev, file]);
      setTudFName((prev) => [...prev, file.name]);
      setTudFileType((prev) => [...prev, file.name.split(".").pop()]);
      setTudFileSize((prev) => [...prev, file.size]);
    });
    setShowAddBtnTud(true);
  };

  const handleChange = (e) => {
    const Files = e.target.files[0];
    setShowAddBtn(true);
    if (Files) {
      setSelectedFile((prevfiles) => [...prevfiles, Files]);
      setFName((prevfiles) => [...prevfiles, Files.name]);
      setFileType((prevfiles) => [...prevfiles, Files.name.split(".").pop()]);
      setFileSize((prevfiles) => [...prevfiles, Files.size]);
    }
  };

  const handleTudChange = (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;
    const invalid = files.some((f) => {
      const ext = (f?.name || "").split(".").pop().split("?")[0].toLowerCase();
      return !["doc", "docx"].includes(ext);
    });
    if (invalid) {
      message.error("Only .doc and .docx files are allowed for DOU files");
      e.target.value = "";
      return;
    }
    setShowAddBtnTud(true);
    files.forEach((file) => {
      setSelectedTUDFile((prev) => [...prev, file]);
      setTudFName((prev) => [...prev, file.name]);
      setTudFileType((prev) => [...prev, file.name.split(".").pop()]);
      setTudFileSize((prev) => [...prev, file.size]);
    });
  };

  const onButtonClick = () => {
    inputRef.current.click();
  };

  const onButtonClicktud = () => {
    tudInputRef.current.click();
  };

  const onButtonClickTestCase = () => {
    testCaseInputRef.current && testCaseInputRef.current.click();
  };

  const resetTestCaseUpload = () => {
    setSelectedTestCaseFile([]);
    setTestCaseFName([]);
    setTestCaseFileType([]);
    setTestCaseFileSize([]);
    setTestCaseFileUrl([]);
    setShowAddBtnTestCase(false);
  };

  const removeTestCaseImage = (index) => {
    if (testCaseFileUrl.length === 1 && index === 0) {
      testCaseInputRef.current.value = "";
      setShowAddBtnTestCase(false);
    }
    setTestCaseFileUrl([
      ...testCaseFileUrl.slice(0, index),
      ...testCaseFileUrl.slice(index + 1),
    ]);
    setTestCaseFileSize([
      ...testCaseFileSize.slice(0, index),
      ...testCaseFileSize.slice(index + 1),
    ]);
    setTestCaseFName([
      ...testCaseFName.slice(0, index),
      ...testCaseFName.slice(index + 1),
    ]);
    setTestCaseFileType([
      ...testCaseFileType.slice(0, index),
      ...testCaseFileType.slice(index + 1),
    ]);
    setSelectedTestCaseFile([
      ...selectedTestCaseFile.slice(0, index),
      ...selectedTestCaseFile.slice(index + 1),
    ]);
  };

  useEffect(() => {
    if (selectedFile.length < 1) return;
    const newImageURL = [];
    setFileBlob(selectedFile[0]);
    selectedFile.forEach((selectedFile) =>
      newImageURL.push(URL.createObjectURL(selectedFile)),
    );
    setlFileUrl(newImageURL);

    const updatedFilesize = Array.isArray(item.filesize) ? item.filesize : [];
    setUpdatedData((prevState) => {
      return { ...prevState, fileurls: [...fname, ...taskfileList] };
    });
    setUpdatedData((prevState) => {
      return { ...prevState, filesize: [...fileSize, ...updatedFilesize] };
    });
  }, [selectedFile]);

  useEffect(() => {
    if (selectedTUDFile.length < 1) return;
    const newImageURLs = [];
    selectedTUDFile.forEach((file) => {
      const url = URL.createObjectURL(file);
      newImageURLs.push(url);
    });
    setTUDFileUrl(newImageURLs);
  }, [selectedTUDFile]);

  useEffect(() => {
    if (selectedTestCaseFile.length < 1) return;
    const newImageURLs = [];
    selectedTestCaseFile.forEach((file) => {
      const url = URL.createObjectURL(file);
      newImageURLs.push(url);
    });
    setTestCaseFileUrl(newImageURLs);
  }, [selectedTestCaseFile]);

  var FileArrayUpload = [];
  for (var i = 0; i < FileUrl.length; i++)
    FileArrayUpload[i] = [fileType[i], FileUrl[i], fname[i]];

  var FileArrayUploadTud = [];
  for (var i = 0; i < tudFileUrl.length; i++) {
    FileArrayUploadTud[i] = [tudFileType[i], tudFileUrl[i], tudFName[i]];
  }

  var FileArrayUploadTestCase = [];
  for (var i = 0; i < testCaseFileUrl.length; i++) {
    FileArrayUploadTestCase[i] = [
      testCaseFileType[i],
      testCaseFileUrl[i],
      testCaseFName[i],
    ];
  }

  const removeImage = (index) => {
    if (FileUrl.length === 1 && index === 0) {
      inputRef.current.value = "";
      setShowAddBtn(false);
    }
    setlFileUrl([
      ...FileUrl.slice(0, index),
      ...FileUrl.slice(index + 1, FileUrl.length),
    ]);
    setFileSize([
      ...fileSize.slice(0, index),
      ...fileSize.slice(index + 1, fileSize.length),
    ]);
    setFName([
      ...fname.slice(0, index),
      ...fname.slice(index + 1, FileUrl.length),
    ]);
    setFileType([
      ...fileType.slice(0, index),
      ...fileType.slice(index + 1, fileType.length),
    ]);
    setSelectedFile([
      ...selectedFile.slice(0, index),
      ...selectedFile.slice(index + 1, selectedFile.length),
    ]);
    const result = FileArrayUpload.map((element) => element.slice(index));
  };

  const removeImageTUD = (index) => {
    if (tudFileUrl.length === 1 && index === 0) {
      tudInputRef.current.value = "";
      setShowAddBtnTud(false);
    }
    setTUDFileUrl([
      ...tudFileUrl.slice(0, index),
      ...tudFileUrl.slice(index + 1, tudFileUrl.length),
    ]);
    setTudFileSize([
      ...tudFileSize.slice(0, index),
      ...tudFileSize.slice(index + 1, tudFileSize.length),
    ]);
    setFName([
      ...tudFName.slice(0, index),
      ...tudFName.slice(index + 1, tudFileUrl.length),
    ]);
    setTudFileType([
      ...tudFileType.slice(0, index),
      ...tudFileType.slice(index + 1, tudFileType.length),
    ]);
    setSelectedTUDFile([
      ...selectedTUDFile.slice(0, index),
      ...selectedTUDFile.slice(index + 1, selectedTUDFile.length),
    ]);
    const result = FileArrayUploadTud.map((element) => element.slice(index));
  };

  const handleUploadFileTUD = async (trackingid, projectid) => {
    setFileUploadMessageTUD(null);
    setFileLoadingTUD(true);

    // Create updatedFile array with file details and unique ID
    const updatedFile = selectedTUDFile.map((file, index) => ({
      file: file,
      id: new Date().getTime() + index, // Unique ID using timestamp + index
      name: file.name,
      type: file.type, // Include the file type
      subname:
        "DOU-" +
        projectid +
        "-" +
        trackingid +
        "-" +
        moment().format("DD-MM-YYYY HH:mm"),
    }));

    try {
      const uploadPromises = updatedFile.map(async (fileData) => {
        const response = await api.post(
          `/tracking/document/${trackingClientId}?method=upload`,
          {
            tuddocumentid: fileData.id,
            filename: fileData.name,
            name: "tudfile",
          },
          {
            headers: {
              authorizationtoken: `${authToken}`,
            },
          },
        );
        const URL = response.data?.data;

        const putRes = await fetch(URL, {
          method: "PUT",
          headers: {
            "Content-Type": fileData.type || "application/octet-stream",
          },
          body: fileData.file,
        });

        console.log("Upload response:", putRes);
      });

      await Promise.all(uploadPromises);
      const value = updatedFile?.map((item) => {
        return {
          tuddocumentid: item.id,
          filename: item.name,
          subname: item?.subname,
        };
      });
      let Obj = {
        name: "tudfile",
        tudDocument: [...(tudFileList || []), ...value],
      };
      api
        .patch("/tracking/update/" + trackingid, Obj, {
          headers: {
            authorizationtoken: ` ${authToken}`,
          },
        })
        .then(function (response) {
          if (response.data?.status) {
            setShowAddBtnTud(false);
            setTimeout(() => {
              setFileUploadMessageTUD("");
            }, 3000);
            setfileLoading(false);
            setFileUploadMessageTUD("TUD File Uploaded Successfully");
            setTUDFileList([...(tudFileList || []), ...value]);
            setSelectedTUDFile("");
            setFileLoadingTUD(false);
          }
        });
    } catch (error) {
      console.log("Error uploading files:", error);
      setFileLoadingTUD(false);
    }
  };

  const handleUploadFile = async (trackingid) => {
    const base64file = await fileToBase64(fileBlob);
    setFileUploadMessage(null);
    setFileLoading(true);
    try {
      const response = await api.post(
        "/tracking/fileupload",
        {
          trackingclientid: trackingClientId,
          trackingid: trackingid,
          fileurls: fileBlob.name,
          fileType: fileBlob.type,
          filedata: base64file,
        },
        {
          headers: {
            authorizationtoken: ` ${authToken}`,
          },
        },
      );
      let Filename = fileBlob?.name;
      setCurrentFilename(Filename);
      closeFileupload();
      setfileLoading(false);
      setFileUploadMessage(response.data.message);

      getFetchFileData({
        trackingid: trackingid,
        fileurls: [...item.fileurls, Filename],
      });

      updateTask("fileurls", [...item.fileurls, Filename]);
      // setTaskFile((prevfiles) => [...prevfiles, response.data.url])
      // if (Filename) {
      //   setTaskFileType((prevfiles) => [...prevfiles, Filename.split(".").pop()])
      //   setTaskFileList((prevfiles) => [...prevfiles, Filename])
      // }
    } catch (error) {
      console.log(error);
    }
  };

  const [fileArray, setFileArray] = useState([]);

  useEffect(() => {
    let files = [];

    if (taskfile) {
      for (let i = 0; i < taskfile.length; i++) {
        files[i] = [taskfileType[i], taskfile[i], taskfileList[i]];
      }

      setFileArray(files);
    }

    return () => {
      setFileArray([]);
    };
  }, [taskfile, taskfileType, taskfileList]);

  const initial = [];
  const resetImage = () => {
    setTaskFile(initial);
    setShowAddBtn(false);
    setShowSaveBtn(false);
    setTaskFileType(initial);
    setTaskFileList(initial);
    setSelectedFile(initial);
    setFName(initial);
    setFileType(initial);
    setlFileUrl(initial);
    setDeletedFile(initial);
    setFileSize(initial);
  };
  const resetUpload = () => {
    setSelectedFile(initial);
    setFName(initial);
    setFileType(initial);
    setlFileUrl(initial);
    setFileSize(initial);
  };

  const tudDelete = (index) => {
    setTUDFileList((prevfiles) => {
      const updatedFiles = [...prevfiles];
      updatedFiles.splice(index, 1); // Remove the file at the specified index
      return updatedFiles;
    });
  };

  const deleteFile = (index) => {
    setDeletedFile((prevfiles) => [...prevfiles, taskfileList[index]]);

    if (taskfileList) {
      setTaskFileList([
        ...taskfileList.slice(0, index),
        ...taskfileList.slice(index + 1, taskfileList.length),
      ]);
    }

    if (fileArray) {
      const result = fileArray.map((element) => element.slice(index));
    }

    if (taskfileType) {
      setTaskFileType([
        ...taskfileType.slice(0, index),
        ...taskfileType.slice(index + 1, taskfileType.length),
      ]);
    }

    if (taskfile) {
      setTaskFile([
        ...taskfile.slice(0, index),
        ...taskfile.slice(index + 1, taskfile.length),
      ]);
    }

    if (taskfilesize) {
      setTaskFilesize([
        ...taskfilesize.slice(0, index),
        ...taskfilesize.slice(index + 1, taskfilesize.length),
      ]);
    }
  };

  const DeleteFile = () => {
    let Obj = deletedFile;

    api
      .post("/tracking/update/" + item.trackingid, Obj, {
        headers: {
          authorizationtoken: ` ${authToken}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.status === true) {
            setDeletedFile([]);
          }
        }
      })
      .catch(function (error) {
        setDeletedFile([]);
      });
  };

  useEffect(() => {
    if (taskfileList) {
      setUpdatedData((prevState) => {
        return { ...prevState, fileurls: taskfileList };
      });
    }
  }, [taskfileList]);

  const handleSplChar = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      editItem("title");
      updateTask("title", updatedData.title);
      setShowEditTask((prevState) => {
        return { ...prevState, editTitle: false };
      });
    }
    if (
      e.key === "#" ||
      e.key === "$" ||
      e.key === "^" ||
      e.key === "@" ||
      e.key === "*" ||
      e.key === "(" ||
      e.key === "!" ||
      e.key === ")" ||
      e.key === "%" ||
      e.key === "="
    ) {
      e.preventDefault();
    }
  };

  const exceptThisSymbols = ["e", "E", "+", "-", "."];

  // async function writeClipImg(imageBase64) {
  //   try {
  //     const blob = await (await fetch(`data:image/png;base64,${imageBase64}`)).blob()
  //     if (navigator.clipboard && navigator.clipboard.write) {
  //       await navigator.clipboard.write([
  //         new ClipboardItem({
  //           [blob.type]: blob
  //         })
  //       ])
  //     } else {
  //       console.error("Clipboard API not available")
  //     }
  //   } catch (err) {
  //     console.error("Error while fetching or writing to clipboard:", err)
  //   }
  // }
  console.log("priorityOptions4", priorityOptions);

  const downloadTUD = async (id, name) => {
    const response = await api.post(
      `/tracking/tuddocument/${trackingClientId}?method=view`,
      {
        tuddocumentid: id,
        filename: name,
        name: "tudfile",
      },
      {
        headers: {
          authorizationtoken: `${authToken}`,
        },
      },
    );
    if (data?.status) {
      const newTab = window.open(response?.data?.data, "_blank");
    } else {
      console.log("TUD Response", response);
    }
  };

  const downloadFile = (url, fileName) => {
    const newTab = window.open(url, "_blank");

    if (!newTab || newTab.closed || typeof newTab.closed == "undefined") {
      alert("Please disable your pop-up blocker and try again.");
    }
    // const fileUrl = url
    // fetch(fileUrl)
    //   .then((response) => response.blob())
    //   .then((blob) => {
    //     const url = window.URL.createObjectURL(blob)
    //     const link = document.createElement("a")
    //     link.href = url
    //     link.setAttribute("download", fileName)
    //     link.style.display = "none" // Hide the link
    //     document.body.appendChild(link)
    //     link.click()
    //     document.body.removeChild(link)
    //   })
    //   .catch((error) => {
    //     console.error("Error downloading the file:", error)
    //   })
  };

  const [viewBaclogsToggle, setViewBacklogsToggle] = useState("");
  const [showAddBacklogstModal, setShowAddBacklogsModal] = useState(false);
  const [moveTrackingId, setMoveTrackingId] = useState("");
  let forBacklogsModel = true;

  const fetchViewBacklogssList = (element) => {
    setLoading(true);
    let url = `/backloglist/${trackingClientId}/${element}`;
    api
      .post(url)
      .then(function (response) {
        if (response.data.status === true) {
          if (menu === "alltask") {
            let index = allTrackingsList.findIndex(
              (ele) => ele.trackingid === element,
            );
            if (index >= 0) {
              allTrackingsList.splice(index, 1);
            }
          } else {
            let index = myTrackingList.findIndex(
              (ele) => ele.trackingid === element,
            );
            if (index >= 0) {
              myTrackingList.splice(index, 1);
            }
          }
          allBacklogs.push(index);
          dispatch(setAllTrackings([...allTrackingsList]));
          client.setQueryData([key.get_backlogs_data], (oldData) => {
            return {
              ...oldData,
              data: allBacklogs,
            };
          });
        }
        setTaskview("AllTask");
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const onRadiobtnHandler = (e, value) => {
    setSelectedRadioValue(e.target.value);
    if (value && value.name === e.target.name) {
      setViewBacklogsToggle((p) => ({
        ...p,
        [e.target.name]: e.target.value,
      }));
    }
  };

  const handleMoveBacklogsModel = (item) => {
    setMoveTrackingId(item);
    setShowAddBacklogsModal(true);
  };

  const handleRaiseFlagChange = (e) => {
    const selectedValue = e.target.value;

    const selectedFlag = FlagOptions.find(
      (item) => item.value === selectedValue,
    );

    if (selectedFlag) {
      setViewTaskData((prevState) => ({
        ...prevState,
        raiseflag: [
          {
            flagpersonemail: userid,
            flagid: selectedFlag.id,
            flagetype: selectedFlag.value,
          },
        ],
      }));
      setChangedFlagVal({
        raiseflag: [
          {
            flagpersonemail: userid,
            flagid: selectedFlag.id,
            flagetype: selectedFlag.label,
          },
        ],
      });
    }
  };

  const handleclickpriorityedit = () => {};
  console.log("priorityOptions5", priorityOptions);

  return (
    <TrackingViewWrap>
      <TrackingModalView>
        {selected_menu == "archive" ||
          selected_menu == "taskapproval" ||
          (selected_menu == "myreopen" && (
            <ArrowCircleLeftIcon
              className="closeicon"
              onClick={() => {
                setTaskview("AllTask");
                resetImage();
              }}
              style={{ cursor: "pointer", fontSize: "25px" }}
            />
          ))}

        <h4>
          <ArrowCircleLeftIcon
            className="closeicon"
            onClick={() => {
              setTaskview("AllTask");
              resetImage();
            }}
            style={{ cursor: "pointer", fontSize: "25px" }}
          />

          <div style={{ width: "100%" }}>
            {showEditTask && showEditTask.editTitle ? (
              <>
                <Row>
                  <Col sm={8} md={9} lg={9}>
                    <input
                      ref={titleRef}
                      type="text"
                      value={updatedData.title}
                      onKeyDown={handleSplChar}
                      onChange={(e) =>
                        setUpdatedData((prevState) => {
                          return { ...prevState, title: e.target.value };
                        })
                      }
                      style={{ fontSize: 24 }}
                      maxLength="80"
                      className="form-control p-0 ps-2"
                    />
                  </Col>
                  <Col sm={4} md={3} lg={3}>
                    <div
                      className="titledit"
                      style={{ zIndex: 1, position: "relative" }}
                    >
                      <Button
                        size="sm"
                        variant="secondary"
                        style={{
                          color: "#9d9d9d",
                          background: "#f1f1f1",
                          borderColor: "#d3d3d3",
                        }}
                        className="titleedit me-1 ps-3 pe-3 border-none"
                        onClick={(e) => {
                          updateTask("title", updatedData.title);
                          setShowEditTask((prevState) => {
                            return { ...prevState, editTitle: false };
                          });
                        }}
                      >
                        <CheckIcon className="titleicon" />
                      </Button>
                      <Button
                        size="sm"
                        variant="secondary"
                        style={{
                          color: "#9d9d9d",
                          background: "#f1f1f1",
                          borderColor: "#d3d3d3",
                        }}
                        className="titleedit ps-3 pe-3  border-none"
                        onClick={(e) =>
                          setShowEditTask((prevState) => {
                            return { ...prevState, editTitle: false };
                          })
                        }
                      >
                        <CloseIcon className="titleicon" />
                      </Button>
                    </div>
                  </Col>
                </Row>
              </>
            ) : (
              <span
                style={{ width: "90%" }}
                className="edit-content title pt-0"
              >
                {data?.title}
                <img
                  src={CopyIcon}
                  alt="editIcon"
                  height={17}
                  width={17}
                  style={{
                    marginTop: "0.7%",
                    marginLeft: "1%",
                    cursor: "pointer",
                  }}
                  onClick={copyText}
                />
                <span
                  style={{
                    fontSize: "15px",
                    color: "#4EB6EE",
                    marginTop: "0.7%",
                    marginLeft: "1%",
                  }}
                >
                  {textCopyMsg}
                </span>
                {editPermission && (
                  <img
                    src={EditIcon}
                    alt="editIcon"
                    height={19}
                    width={19}
                    style={{
                      marginLeft: "0.3%",
                      cursor: "pointer",
                      marginTop: "0.5%",
                    }}
                    onClick={(e) => {
                      editItem("title");
                    }}
                  />
                )}
              </span>
            )}
          </div>
        </h4>
        <div className="taskconatiner p-2">
          <div
            className="m-2 my-4 clone-box"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            {selected_menu !== "archive" && (
              <>
                {!isModalView ? (
                  <>
                    <div
                      className="clone"
                      onClick={(e) => {
                        e.stopPropagation(); // Prevent row click or parent click
                        setTaskview("Clone"); // Navigate back to AllTask
                        setShowClone(true); // Open clone popup
                      }}
                    >
                      <FileCopyIcon /> <strong>Clone</strong>
                    </div>
                    {/* Only show approve button if selected_menu is exactly 'taskapproval' */}
                    {selected_menu === "taskapproval" &&
                      (approved ? (
                        <button
                          style={{
                            color: "white",
                            background: "green",
                            fontWeight: 600,
                            fontSize: 16,
                            marginLeft: "auto",
                            border: "none",
                            borderRadius: 4,
                            padding: "4px 18px",
                            cursor: "default",
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                          }}
                          disabled
                        >
                          <CheckIcon style={{ marginRight: 4 }} /> Approved
                        </button>
                      ) : (
                        <button
                          style={{
                            color: "white",
                            background: "green",
                            fontWeight: 600,
                            fontSize: 16,
                            marginLeft: "auto",
                            border: "none",
                            borderRadius: 4,
                            padding: "4px 18px",
                            cursor: "pointer",
                          }}
                          onClick={async () => {
                            try {
                              // Build payload
                              let actualTimeline = null;
                              if (data?.eta || data?.timeline) {
                                const sla = (data?.eta || data?.timeline) + "";
                                const slaMatch = sla.match(
                                  /(\d+)\s*(hr|hrs|hour|hours|day|days)/i,
                                );
                                if (slaMatch) {
                                  const value = parseInt(slaMatch[1], 10);
                                  const unit = slaMatch[2].toLowerCase();
                                  let momentUnit = "hours";
                                  if (unit.includes("day")) momentUnit = "days";
                                  actualTimeline = moment()
                                    .utcOffset("+05:30")
                                    .add(value, momentUnit)
                                    .toISOString();
                                } else {
                                  actualTimeline = moment()
                                    .utcOffset("+05:30")
                                    .toISOString();
                                }
                              } else {
                                actualTimeline = moment()
                                  .utcOffset("+05:30")
                                  .toISOString();
                              }

                              const payload = {
                                action: "deadlineapproved",
                                actualTimeline: actualTimeline, // ✅ extra payload
                              };

                              // API call
                              await api.patch(
                                `/taskapproval/${trackingClientId}/${item.trackingid}`,
                                payload,
                                {
                                  headers: {
                                    authorizationtoken: `${authToken}`,
                                  },
                                },
                              );

                              setApproved(true);
                              if (typeof setApprovalMsg === "function") {
                                setApprovalMsg(
                                  "Task approved and ready to start",
                                );
                                setTimeout(() => setApprovalMsg(""), 2000);
                              }

                              // Wait 1s to show Approved, then go back
                              setTimeout(() => {
                                if (typeof setTaskview === "function") {
                                  setTaskview("table");
                                }
                                if (
                                  typeof window !== "undefined" &&
                                  window.api
                                ) {
                                  window.api.get(
                                    `/taskapproval/${trackingClientId}`,
                                  );
                                  window.location.reload();
                                } else if (
                                  typeof api === "object" &&
                                  typeof api.get === "function"
                                ) {
                                  api.get(`/taskapproval/${trackingClientId}`);
                                  window.location.reload();
                                }
                              }, 1000);
                            } catch (err) {
                              console.error("Error approving task:", err);
                            }
                          }}
                        >
                          Approve
                        </button>
                      ))}
                  </>
                ) : (
                  <div></div>
                )}
              </>
            )}

            {deletePermission && (
              <IconButton color="error">
                <DeleteIcon
                  onClick={(e) => {
                    setDeleteConfirmationShow(true);
                    setTrackingItemData(
                      (selected_menu === "all_tasks"
                        ? allTrackingsList
                        : myTrackingList
                      ).find(
                        (element) => element.trackingid === item.trackingid,
                      ),
                    );
                  }}
                />
              </IconButton>
            )}
          </div>
          <Table className="trackingviewtable">
            <tbody className="trackingviewtbody">
              <div className="trackingviewtbody">
                <Row>
                  <Col sm={12} md={12} lg={6}>
                    <tr className="">
                      <td className="border-0 tr-color select-options">
                        <strong>Task No:</strong>
                      </td>
                      <td className=" border-0  text-capitalize">
                        <strong className="edit-content tr-color">
                          {trackingClientId}-{item.trackingid}
                          <img
                            src={CopyIcon}
                            height={15}
                            width={15}
                            style={copyIconCSS}
                            onClick={copyTicketNumber}
                            alt="copy_icon"
                          />
                          <span
                            style={{
                              marginLeft: "4%",
                              color: "#4EB6EE",
                              fontWeight: "300",
                            }}
                          >
                            {msg}
                          </span>
                        </strong>
                      </td>
                    </tr>
                  </Col>
                  {backlogsPermission?.view == true &&
                    backlogsPermission?.edit == true && (
                      <Col sm={12} md={12} lg={6}>
                        <tr className="tr-color">
                          <td className="border-0 select-options datarow">
                            Backlogs:
                          </td>
                          <td className="border-0 text-capitalize">
                            <div className="backlogs_radio_btns">
                              <div>
                                <Form.Check
                                  label="Yes"
                                  name="backlogs"
                                  type="radio"
                                  value="Yes"
                                  checked={selectedRadioValue === "Yes"}
                                  onChange={(e) => {
                                    handleMoveBacklogsModel(item.trackingid);
                                  }}
                                />
                              </div>
                              <div>
                                <Form.Check
                                  label="No"
                                  name="backlogs"
                                  type="radio"
                                  value="No"
                                  checked={selectedRadioValue === "No"}
                                  onChange={(e) => {
                                    onRadiobtnHandler(e, value);
                                  }}
                                />
                              </div>
                            </div>
                          </td>
                        </tr>
                      </Col>
                    )}
                  <Col sm={12} md={12} lg={6}>
                    <tr className="tr-color ">
                      <td className="border-0 select-options datarow">
                        Project:
                      </td>
                      <td className="border-0 text-capitalize">
                        {showEditTask && showEditTask.editProject ? (
                          <div className="d-flex">
                            <Form.Select
                              className="select-options"
                              size="sm"
                              value={data.projectid}
                              onChange={(e) => {
                                setViewTaskData((prevState) => {
                                  return {
                                    ...prevState,
                                    projectid: e.target.value,
                                  };
                                });
                              }}
                            >
                              {allProjectsData.map((item, index) => (
                                <option
                                  value={item.trackingprojectid}
                                  key={index}
                                >
                                  {item.label}
                                </option>
                              ))}
                            </Form.Select>
                            <div
                              className="ms-2 text-center edit-cross"
                              onClick={(e) => {
                                setShowEditTask((prevState) => {
                                  return { ...prevState, editProject: false };
                                });
                                updateTask(
                                  "trackingprojectsid",
                                  data.projectid,
                                );
                                updateTask("assignedto", "notAssigned");
                                setViewTaskData((prevState) => {
                                  return {
                                    ...prevState,
                                    assignedTo: "notAssigned",
                                  };
                                });
                              }}
                            >
                              <CheckIcon style={tickCloseIconCSS} />
                            </div>
                            <div
                              className="ms-2 text-center edit-cross"
                              onClick={(e) => {
                                setShowEditTask((prevState) => {
                                  return { ...prevState, editProject: false };
                                });
                                setViewTaskData(previousData);
                              }}
                            >
                              <CloseIcon style={tickCloseIconCSS} />
                            </div>
                          </div>
                        ) : (
                          <span className="edit-content datarow">
                            {projectName}
                            {editPermission && (
                              <img
                                src={EditIcon}
                                alt="editIcon"
                                height={17}
                                width={17}
                                style={editIconCSS}
                                onClick={(e) => editItem("project")}
                              />
                            )}
                          </span>
                        )}
                      </td>
                    </tr>
                  </Col>
                  <Col sm={12} md={12} lg={6}>
                    <tr className="tr-color ">
                      <td className="border-0 select-options trackingdatarow">
                        Task type:
                      </td>
                      <td className="border-0 text-capitalize">
                        {showEditTask && showEditTask.editTaskType ? (
                          <div className="d-flex">
                            <Form.Select
                              className="select-options"
                              size="sm"
                              value={data.taskType}
                              onChange={(e) => {
                                setViewTaskData((prevState) => {
                                  return {
                                    ...prevState,
                                    taskType: e.target.value,
                                  };
                                });
                              }}
                            >
                              {taskTypeOptions?.map((item, index) => (
                                <option value={item.id} key={index}>
                                  {item.label}
                                </option>
                              ))}
                            </Form.Select>
                            <div
                              className="ms-2 text-center edit-cross"
                              onClick={(e) => {
                                setShowEditTask((prevState) => {
                                  return { ...prevState, editTaskType: false };
                                });
                                updateTask("type", data.taskType);
                              }}
                            >
                              <CheckIcon style={tickCloseIconCSS} />
                            </div>
                            <div
                              className="ms-2 text-center edit-cross"
                              onClick={(e) => {
                                setShowEditTask((prevState) => {
                                  return { ...prevState, editTaskType: false };
                                });
                                setViewTaskData(previousData);
                              }}
                            >
                              <CloseIcon style={tickCloseIconCSS} />
                            </div>
                          </div>
                        ) : (
                          <span className="edit-content trackingdatarow">
                            {taskName}
                            {/* {editPermission && (
                              <img
                                src={EditIcon}
                                alt='editIcon'
                                height={17}
                                width={17}
                                style={editIconCSS}
                                onClick={(e) => editItem("task_type")}
                              />
                            )} */}
                          </span>
                        )}
                      </td>
                    </tr>
                  </Col>
                  <Col sm={12} md={12} lg={6}>
                    <tr className="tr-color ">
                      <td className="border-0 select-options datarow">
                        Reported On:
                      </td>
                      <td className="border-0">
                        <span className="edit-content datarow">
                          {moment(item.reporteddate).format(
                            "MMM D, YYYY hh:mm A",
                          )}
                        </span>
                      </td>
                    </tr>
                  </Col>
                  <Col sm={12} md={12} lg={6}>
                    <tr className="tr-color ">
                      <td className="border-0 select-options trackingdatarow">
                        Reported by:
                      </td>
                      <td className="border-0">
                        <span
                          className="edit-content trackingdatarow"
                          onClick={(e) => editItem("reported_by")}
                        >
                          {console.log("reportedByName", reportedByName)}{" "}
                          {reportedByName}
                        </span>
                      </td>
                    </tr>
                  </Col>
                  {/* {type !== "approve" && (
                    <Col sm={12} md={12} lg={6}>
                      <tr className='tr-color '>
                        <td className='border-0 select-options trackingdatarow'>Timeline: </td>
                        <td className='border-0'>
                          {showEditTask && showEditTask.editTimeline ? (
                            <div className='d-flex edit-content trackingdatarow'>
                              <Form.Control
                                type='number'
                                className='p-0 text-center'
                                style={{ width: "30px" }}
                                onInput={(e) =>
                                  e.target.value.length > e.target.maxLength
                                    ? (e.target.value = e.target.value.slice(0, e.target.maxLength))
                                    : ""
                                }
                                maxlength={3}
                                value={updatedData.timeline}
                                pattern='[0-9]+'
                                onChange={(e) =>
                                  setUpdatedData((prevState) => {
                                    return {
                                      ...prevState,
                                      timeline: e.target.value
                                    }
                                  })
                                }
                                onKeyDown={(e) =>
                                  exceptThisSymbols.includes(e.key) && e.preventDefault()
                                }
                              />
                              <div
                                className='ms-2 text-center edit-cross'
                                onClick={(e) => {
                                  setShowEditTask((prevState) => {
                                    return {
                                      ...prevState,
                                      editTimeline: false
                                    }
                                  })
                                  updateTask("timeline", updatedData.timeline)
                                }}
                              >
                                <CheckIcon style={tickCloseIconCSS} />
                              </div>
                              <div
                                className='ms-2 text-center edit-cross'
                                onClick={(e) =>
                                  setShowEditTask((prevState) => {
                                    return {
                                      ...prevState,
                                      editTimeline: false
                                    }
                                  })
                                }
                              >
                                <CloseIcon style={tickCloseIconCSS} />
                              </div>
                            </div>
                          ) : (
                            <span className='edit-content'>
                              {data?.timeline ? data?.timeline + " hours" : "-"}
                              {editPermission && (
                                <img
                                  src={EditIcon}
                                  alt='editIcon'
                                  height={17}
                                  width={17}
                                  style={editIconCSS}
                                  onClick={(e) => editItem("timeline")}
                                />
                              )}
                            </span>
                          )}
                        </td>
                      </tr>
                    </Col>
                  )} */}
                  <Col sm={12} md={12} lg={6}>
                    {" "}
                    <tr className="tr-color ">
                      <td className="border-0 select-options trackingdatarow">
                        Assigned To:
                      </td>
                      <td className="border-0">
                        {showEditTask && showEditTask?.editAssignedTo ? (
                          <div className="d-flex">
                            <Form.Select
                              className="select-options"
                              size="sm"
                              value={
                                data.assignedTo !== ""
                                  ? data.assignedTo
                                  : "notAssigned"
                              }
                              onChange={(e) => {
                                setViewTaskData((prevState) => {
                                  return {
                                    ...prevState,
                                    assignedTo: e.target.value,
                                  };
                                });
                              }}
                            >
                              <option value="">Select...</option>
                              {allMembers.map((item, index) => (
                                <option value={item.id} key={index}>
                                  {item.label}
                                </option>
                              ))}
                            </Form.Select>
                            <div
                              className="ms-2 text-center edit-cross"
                              onClick={(e) => {
                                setShowEditTask((prevState) => {
                                  return {
                                    ...prevState,
                                    editAssignedTo: false,
                                  };
                                });
                                const assignedTo = allMembers?.find(
                                  (e) => e?.id === data?.assignedTo,
                                )?.id;

                                // if (assignedTo !== "notAssigned")
                                updateTask("assignedto", assignedTo);
                              }}
                            >
                              <CheckIcon style={tickCloseIconCSS} />
                            </div>
                            <div
                              className="ms-2 text-center edit-cross"
                              onClick={(e) => {
                                setShowEditTask((prevState) => {
                                  return {
                                    ...prevState,
                                    editAssignedTo: false,
                                  };
                                });
                                setViewTaskData(previousData);
                              }}
                            >
                              <CloseIcon style={tickCloseIconCSS} />
                            </div>
                          </div>
                        ) : (
                          <span className="edit-content trackingdatarow">
                            {assignedToName !== "" &&
                            assignedToName !== undefined
                              ? assignedToName
                              : "Not Assigned"}
                            {editPermission && (
                              <img
                                src={EditIcon}
                                alt="editIcon"
                                style={editIconCSS}
                                height={17}
                                width={17}
                                onClick={(e) => editItem("assigned_to")}
                              />
                            )}
                          </span>
                        )}
                      </td>
                    </tr>
                  </Col>
                  <Col md={12} lg={6} sm={12}>
                    <tr className="tr-color ">
                      <td className="border-0 select-options datarow">
                        Priority:{" "}
                      </td>
                      <td className="border-0 text-capitalize">
                        {showEditTask && showEditTask.editPriority ? (
                          <div className="d-flex">
                            <Form.Select
                              className="select-options"
                              size="sm"
                              value={data.priority}
                              onChange={(e) => {
                                setViewTaskData((prevState) => {
                                  return {
                                    ...prevState,
                                    priority: e.target.value,
                                  };
                                });
                              }}
                            >
                              {/* {priorityOptions.map((item, index) => (
                                <option value={item.id} key={index}>
                                  {item.label}
                                </option>
                              ))} */}
                              {console.log("priorityOptions6", priorityOptions)}
                              {priorityOptions.map((item, index) => {
                                return (
                                  <option value={item.id} key={index}>
                                    {item.label}
                                  </option>
                                );
                              })}
                            </Form.Select>
                            <div
                              className="ms-2 text-center edit-cross"
                              onClick={(e) => {
                                setShowEditTask((prevState) => {
                                  return { ...prevState, editPriority: false };
                                });
                                updateTask("priority", data.priority);
                              }}
                            >
                              <CheckIcon style={tickCloseIconCSS} />
                            </div>
                            <div
                              className="ms-2 text-center edit-cross"
                              onClick={(e) => {
                                setShowEditTask((prevState) => {
                                  return { ...prevState, editPriority: false };
                                });
                                setViewTaskData(previousData);
                              }}
                            >
                              <CloseIcon style={tickCloseIconCSS} />
                            </div>
                          </div>
                        ) : (
                          <span
                            onClick={() => {
                              handleclickpriorityedit();
                            }}
                            className="edit-content datarow"
                          >
                            {data?.priority === "blocker" ||
                            data?.priority === "blocker1"
                              ? "Blocker Level 1"
                              : data?.priority === "blocker2"
                                ? "Blocker Level 2"
                                : data?.priority}{" "}
                            {editPermission && (
                              <img
                                src={EditIcon}
                                alt="editIcon"
                                height={17}
                                width={17}
                                style={editIconCSS}
                                onClick={(e) => editItem("priority")}
                              />
                            )}
                          </span>
                        )}
                      </td>
                    </tr>
                  </Col>
                  {type != "approve" && (
                    <Col md={12} lg={6} sm={12}>
                      <tr className="tr-color ">
                        <td className="border-0 select-options trackingdatarow">
                          Status:{" "}
                        </td>
                        <td className="border-0">
                          {showEditTask && showEditTask.editStatus ? (
                            <div className="d-flex">
                              <Form.Select
                                className="select-options"
                                size="sm"
                                value={data?.status || "-"}
                                onChange={(e) => {
                                  setViewTaskData((prevState) => ({
                                    ...prevState,
                                    status: e.target.value,
                                  }));
                                }}
                              >
                                {data.status_list.map((item, index) => {
                                  const currentIndex =
                                    data.status_list.findIndex(
                                      (s) =>
                                        Number(s.id) === Number(data.status),
                                    );

                                  return (
                                    <option
                                      value={item.id}
                                      key={index}
                                      // disabled={index < currentIndex}
                                    >
                                      {item.label}
                                    </option>
                                  );
                                })}
                              </Form.Select>
                              <div
                                className="ms-2 text-center edit-cross"
                                onClick={(e) => {
                                  setShowEditTask((prevState) => {
                                    return { ...prevState, editStatus: false };
                                  });
                                  updateTask(
                                    "trackingprojectstatusid",
                                    data.status,
                                  );
                                }}
                              >
                                <CheckIcon style={tickCloseIconCSS} />
                              </div>
                              <div
                                className="ms-2 text-center edit-cross"
                                onClick={(e) => {
                                  setShowEditTask((prevState) => {
                                    return { ...prevState, editStatus: false };
                                  });
                                  setViewTaskData(previousData);
                                }}
                              >
                                <CloseIcon style={tickCloseIconCSS} />
                              </div>
                            </div>
                          ) : (
                            <span className="edit-content trackingdatarow">
                              {item?.approvalaction === "accepted" ? (
                                <>
                                  {workflowName}
                                  {editPermission && (
                                    <img
                                      src={EditIcon}
                                      alt="editIcon"
                                      height={17}
                                      width={17}
                                      style={editIconCSS}
                                      onClick={(e) => editItem("status")}
                                    />
                                  )}
                                </>
                              ) : (
                                <Tooltip title="Task must be accepted before status can be updated.">
                                  <span>{workflowName}</span>
                                </Tooltip>
                              )}
                            </span>
                          )}
                        </td>
                      </tr>
                    </Col>
                  )}
                  <Col sm={12} md={12} lg={6}>
                    <tr className="tr-color">
                      <td className="border-0 select-options datarow">
                        Expected SLA:
                      </td>
                      <td className="border-0">
                        <span className="edit-content datarow">
                          {!item.eta && !item.sla
                            ? "-"
                            : `${(item.eta || item.sla).toString().replace(/hrs?/i, "").trim()} hrs`}
                        </span>
                      </td>
                    </tr>
                  </Col>

                  <Col sm={12} md={12} lg={6}>
                    <tr className="tr-color">
                      <td className="border-0 select-options datarow">
                        Expected Deadline:
                      </td>
                      <span className="edit-content datarow">
                        {console.log(
                          item.deadline,
                          "expeteddealine",
                          item.expecteddeadline,
                        )}
                        {
                          !item.deadline && !item.expecteddeadline
                            ? "-"
                            : moment(
                                item.deadline || item.expecteddeadline, // ✅ check both
                                [
                                  moment.ISO_8601,
                                  "DD-MM-YYYY HH:mm",
                                  "DD/MM/YYYY, HH:mm",
                                  "DD/MM/YYYY, hh:mm A",
                                  "DD/MM/YYYY, hh:mm a",
                                  "YYYY-MM-DD HH:mm:ss",
                                  "MMM D, YYYY, hh:mm A",
                                  "MMM D, YYYY hh:mm A",
                                ],
                                true,
                              )
                                .utcOffset("+05:30") // convert to IST
                                .format("MMM D, YYYY h:mm A") // clean format
                        }
                      </span>
                      {editPermission && (
                        <img
                          src={EditIcon}
                          alt="editIcon"
                          height={17}
                          width={17}
                          style={editIconCSS}
                          onClick={() => setIseditItem(true)}
                        />
                      )}
                      {console.log(iseditItem, "iseditItemiseditItem")}
                      {iseditItem && editPermission && (
                        // <DatePicker
                        //   onChange={(date) => {
                        //     const isoDate = date
                        //       ?.utc()
                        //       .format("YYYY-MM-DDTHH:mm:ss[Z]");
                        //     updateTask("deadline", isoDate);
                        //     setDeadline(date);
                        //   }}
                        //   disabledDate={disabledDate}
                        //   // style={{ zIndex: 9991000 }}
                        //   value={deadline}
                        //   format="YYYY-MM-DD"
                        //   placeholder="Select date"
                        //   getPopupContainer={(triggerNode) =>
                        //     triggerNode.parentNode
                        //   }
                        // />
                        <DatePicker
                          onChange={(date) => {
                            const formattedDate = dayjs(date).format(
                              "YYYY-MM-DDTHH:mm:ss[Z]",
                            );

                            console.log(formattedDate);

                            setDeadline(date);
                            updateTask("deadline", formattedDate);
                            setIseditItem(false);
                          }}
                          disabledDate={disabledDate}
                          value={deadline}
                          format="YYYY-MM-DD"
                          placeholder="Select date"
                          getPopupContainer={(triggerNode) =>
                            triggerNode.parentNode
                          }
                        />
                      )}
                    </tr>
                  </Col>

                  <Col md={12} lg={6} sm={12}>
                    <tr className="tr-color ">
                      <td className="border-0 select-options datarow">
                        Raise Flag:{" "}
                      </td>
                      <td className="border-0 text-capitalize">
                        {showEditTask?.editraiseflag ? (
                          <div className="d-flex">
                            <Form.Select
                              className="select-options"
                              size="sm"
                              value={
                                // Show the flag label in dropdown if data.raiseflag exists
                                data?.raiseflag
                                  ? FlagOptions.find(
                                      (f) =>
                                        f.id === data?.raiseflag?.[0]?.flagid,
                                    )?.value
                                  : "select"
                              }
                              onChange={(e) => {
                                if (e.target.value === "select") {
                                  setViewTaskData((prev) => ({
                                    ...prev,
                                    raiseflag: "",
                                    flagtype: "",
                                  }));
                                  return;
                                }
                                handleRaiseFlagChange(e);
                              }}
                            >
                              <option value="select">Select</option>
                              {FlagOptions.map((item, index) => (
                                <option value={item.value} key={index}>
                                  {item.label}
                                </option>
                              ))}
                            </Form.Select>

                            <div
                              className="ms-2 text-center edit-cross"
                              onClick={() => {
                                setShowEditTask((prev) => ({
                                  ...prev,
                                  editraiseflag: false,
                                }));
                                updateTask("raiseflag", data?.raiseflag);
                              }}
                            >
                              <CheckIcon style={tickCloseIconCSS} />
                            </div>

                            <div
                              className="ms-2 text-center edit-cross"
                              onClick={() => {
                                setShowEditTask((prev) => ({
                                  ...prev,
                                  editraiseflag: false,
                                }));
                                setViewTaskData(previousData);
                              }}
                            >
                              <CloseIcon style={tickCloseIconCSS} />
                            </div>
                          </div>
                        ) : (
                          <span className="edit-content datarow">
                            {data?.raiseflag?.[0]?.flagetype || "-"}
                            {editPermission && (
                              <img
                                src={EditIcon}
                                alt="editIcon"
                                height={17}
                                width={17}
                                style={editIconCSS}
                                onClick={() => editItem("raiseflag")}
                              />
                            )}
                          </span>
                        )}
                      </td>
                    </tr>
                  </Col>
                  <Col sm={12} md={12} lg={6}>
                    {selected_menu === "taskapproval" && (
                      <tr className="tr-color">
                        <td className="border-0 select-options datarow">
                          Reason:
                        </td>
                        <td className="border-0">
                          <span className="edit-content datarow">
                            {item.reason ? item.reason : "-"}
                          </span>
                        </td>
                      </tr>
                    )}
                  </Col>
                  <Col sm={12} md={12} lg={6}>
                    {selected_menu === "taskapproval" && (
                      <tr className="tr-color">
                        <td className="border-0 select-options datarow">
                          User SLA:
                        </td>
                        <td className="border-0">
                          <span className="edit-content datarow">
                            {item.usersla ? item.usersla : "-"}
                          </span>
                        </td>
                      </tr>
                    )}
                  </Col>

                  {/* Show Actual Timeline and Actual Deadline as disabled until accepted, then show values */}
                  {/* <Col sm={12} md={12} lg={6}>
                    <tr className='tr-color '>
                      <td className='border-0 select-options datarow'>Actual Timeline:</td>
                      <td className='border-0'>
                        <span className='edit-content datarow'>
                          {data?.actualTimeline || item.actualTimeline
                            ? (data?.actualTimeline || item.actualTimeline)
                            : <input type="text" value="-" disabled style={{ background: 'transparent', border: 'none', width: '120px', color: '#888' }} />}
                        </span>
                      </td>
                    </tr>
                  </Col> */}
                </Row>
              </div>{" "}
            </tbody>
          </Table>
          <div className="p-2">
            <p className="mb-1">
              <strong className="tr-color"> Description: </strong>
            </p>
            {showEditTask && editPermission && showEditTask.editDescription ? (
              <div className="mb-4 editor-section">
                <WysiwygEditor
                  editorRef={descriptionRef}
                  handleReturn={(e, des) => {
                    if (e.keyCode === 13) {
                      setShowEditTask((prevState) => {
                        return { ...prevState, editDescription: false };
                      });
                      updateTask("description", des);
                    }
                  }}
                  value={updatedData.description}
                  onChange={(val) =>
                    setUpdatedData((prevState) => {
                      return { ...prevState, description: val };
                    })
                  }
                />
                <div className="text-end">
                  <Button
                    size="sm"
                    sx={{ display: "flex", alignItems: "center" }}
                    variant="secondary"
                    className="titleupdate me-1 ps-3 pe-3 border-none"
                    onClick={(e) => {
                      updateTask("description", updatedData.description);
                    }}
                  >
                    {loading ? (
                      <BarLoader
                        color="#808080"
                        className="bar-loader"
                        size={14}
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      <></>
                    )}
                    <CheckIcon />
                  </Button>
                  <Button
                    size="sm"
                    variant="secondary"
                    className="titlecancel ps-3 pe-3  border-none"
                    onClick={(e) =>
                      setShowEditTask((prevState) => {
                        return { ...prevState, editDescription: false };
                      })
                    }
                  >
                    <CloseIcon />
                  </Button>
                </div>
              </div>
            ) : (
              <Row
                style={{ width: "100%" }}
                onClick={(e) => editPermission && editItem("description")}
                className="edit-content description-edit"
                dangerouslySetInnerHTML={{ __html: data?.description }}
              />
            )}
          </div>

          {projectNameData?.istudenabled === true &&
            (selected_menu !== "archive" ||
              (selected_menu === "archive" && tudFileList?.length > 0)) && (
              <div className="p-2 mb-3">
                <Row>
                  <Col>
                    {" "}
                    <p className="mb-1">
                      <strong className="tr-color"> DOU Files: </strong>
                    </p>
                  </Col>
                </Row>
                <div className="Filecontainer">
                  {tudFileList?.length > 0 ? (
                    <span>
                      {tudFileList.map((FileArray, index) => {
                        const fileType = FileArray?.filename
                          ?.split(".")
                          .pop()
                          .split("?")[0]
                          ?.toLowerCase();
                        const isDoc = fileType === "doc" || fileType === "docx";

                        return (
                          <div className="file mx-2 my-4" key={index}>
                            {/* ✅ Wrap each file preview inside a relative container */}
                            <div
                              style={{
                                position: "relative",
                                display: "inline-block",
                              }}
                            >
                              {Number(data?.status) === 0 && (
                                <IconButton
                                  onClick={() =>
                                    handleRemoveTUD(item.trackingid, index)
                                  }
                                  style={{
                                    position: "absolute",
                                    top: "0px",
                                    right: "0px",
                                    zIndex: 10,
                                    // backgroundColor: "#fff",
                                    borderRadius: "50%",
                                    padding: "3px",
                                    boxShadow: "0 0 5px rgba(0,0,0,0.2)",
                                  }}
                                >
                                  <HighlightOffIcon
                                    sx={{ fontSize: 18, color: "#d32f2f" }}
                                  />
                                </IconButton>
                              )}

                              {/* 📄 DOC/DOCX FILES */}
                              {isDoc ? (
                                <>
                                  <img
                                    src="https://img.icons8.com/color/144/000000/google-docs--v1.png"
                                    width="120px"
                                    height="120px"
                                    alt="doc"
                                  />
                                  <Tooltip title={FileArray?.subname}>
                                    <p
                                      style={{
                                        width: "113px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        margin: "5px 0",
                                        textAlign: "center",
                                        fontSize: "12px",
                                        cursor: "default",
                                      }}
                                    >
                                      {FileArray?.subname}
                                    </p>
                                  </Tooltip>
                                  <IconButton
                                    style={{ width: "100%" }}
                                    onClick={() =>
                                      downloadTUD(
                                        FileArray?.tuddocumentid,
                                        FileArray?.filename,
                                      )
                                    }
                                  >
                                    <DownloadIcon className="downloadbtn downloadicon" />
                                  </IconButton>
                                </>
                              ) : (
                                /* 🖼️ IMAGE / OTHER FILES */
                                <>
                                  <div className="image-view-document">
                                    <ModalImage
                                      small={FileArray?.fileurl}
                                      large={FileArray?.fileurl}
                                      hideZoom={false}
                                      showRotate={true}
                                    />
                                  </div>
                                  <p className="filename">
                                    {FileArray?.filename}
                                  </p>
                                  <div className="d-flex justify-content-center align-items-center">
                                    <IconButton
                                      onClick={() =>
                                        downloadTUD(
                                          FileArray?.tuddocumentid,
                                          FileArray?.filename,
                                        )
                                      }
                                    >
                                      <DownloadIcon className="downloadbtn" />
                                    </IconButton>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </span>
                  ) : null}
                </div>

                <div className="pt-1">
                  <FormWrap>
                    {editPermission && (
                      <div className="">
                        <form
                          id="form-file-upload"
                          onDragEnter={handleDragtud}
                          onDragLeave={handleDragtud}
                          onDragOver={handleDragtud}
                          onDrop={handleTudDrop}
                        >
                          <input
                            ref={tudInputRef}
                            type="file"
                            id="input-file-upload"
                            name={name}
                            value={value}
                            onChange={(e) => {
                              handleTudChange(e);
                            }}
                            multiple
                            accept=".doc,.docx"
                          />
                          <label
                            id="label-file-upload"
                            className={tudDragActive ? "drag-active" : ""}
                          >
                            <div>
                              <IconButton
                                className="upload-button"
                                onClick={onButtonClicktud}
                              >
                                <UploadFileIcon fontSize="large" />
                              </IconButton>
                              <p className="upload-text">
                                Upload DOU file here
                              </p>
                              <p className="upload-format">
                                Supported formats (Doc)
                              </p>
                            </div>
                          </label>
                          {tudDragActive && (
                            <div
                              id="tud-drag-file-element"
                              onDragEnter={handleDragtud}
                              onDragLeave={handleDragtud}
                              onDragOver={handleDragtud}
                              onDrop={handleTudDrop}
                            ></div>
                          )}
                        </form>
                      </div>
                    )}
                    <div>
                      {fileUploadMessageTUD ? (
                        <Alert className="mt-5" dismissible severity="success">
                          {" "}
                          {fileUploadMessageTUD}{" "}
                        </Alert>
                      ) : null}
                      <div className="Filecontainer">
                        {selectedTUDFile ? (
                          <span>
                            {FileArrayUploadTud.slice(0, 10).map(
                              (FileArrayUploadTud, index) => {
                                return (
                                  <div className="imgRow mb-2 mt-5">
                                    {FileArrayUploadTud[0] == "docx" ||
                                    FileArrayUploadTud[0] == "doc" ||
                                    FileArrayUploadTud[0] == "DOCX" ||
                                    FileArrayUploadTud[0] == "DOC" ? (
                                      <>
                                        <div></div>
                                        <div>
                                          <img
                                            src="https://img.icons8.com/color/144/000000/google-docs--v1.png"
                                            width="113px"
                                            height="110px"
                                            alt="Document"
                                          />
                                          <Tooltip
                                            title={FileArrayUploadTud[2]}
                                          >
                                            <p
                                              style={{
                                                width: "113px",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                margin: "5px 0",
                                                textAlign: "center",
                                                fontSize: "12px",
                                                cursor: "default", // Shows hover cursor
                                              }}
                                            >
                                              {FileArrayUploadTud[2]}
                                            </p>
                                          </Tooltip>
                                        </div>{" "}
                                      </>
                                    ) : (
                                      <>
                                        <div></div>
                                        <div>
                                          <img
                                            src={FileArrayUploadTud[1]}
                                            width="113px"
                                            height="110px"
                                          />
                                          <p className="fileuploadname">
                                            {FileArrayUploadTud[2]}
                                          </p>
                                        </div>
                                      </>
                                    )}

                                    <IconButton
                                      className="removebtn "
                                      onClick={() => removeImageTUD(index)}
                                    >
                                      <HighlightOffIcon fontSize="small" />
                                    </IconButton>
                                  </div>
                                );
                              },
                            )}
                          </span>
                        ) : null}
                      </div>
                    </div>
                  </FormWrap>
                  {showAddBtnTud ? (
                    <>
                      <Button
                        className="btn btn-orange mt-1 float-end"
                        onClick={(e) => {
                          handleUploadFileTUD(
                            item.trackingid,
                            item?.trackingprojectsid,
                          );
                          setViewTaskData((prevState) => {
                            return { ...prevState, fileurls: fname };
                          });
                          setShowEditTask((prevState) => {
                            return { ...prevState, editfileurls: false };
                          });
                          resetUpload();
                        }}
                        style={{
                          background: FileLoadingTUD ? "#FFFFFF" : "#4EB6EE",
                          color: FileLoadingTUD ? "#808080" : "#FFFFFF",
                          border: FileLoadingTUD
                            ? "2px solid #FFFFFF"
                            : "2px solid #4EB6EE",
                        }}
                      >
                        {FileLoadingTUD ? (
                          <BarLoader
                            color="#808080"
                            className="bar-loader"
                            size={14}
                            role="status"
                            aria-hidden="true"
                          />
                        ) : (
                          <></>
                        )}
                        Upload TUD{""}
                      </Button>
                    </>
                  ) : null}
                </div>
              </div>
            )}

          {projectNameData?.istcdenabled === true &&
            (selected_menu !== "archive" ||
              (selected_menu === "archive" &&
                testCaseFileList?.length > 0)) && (
              <div className="p-2 mb-3">
                <Row>
                  <Col>
                    {" "}
                    <p className="mb-1">
                      <strong className="tr-color"> Test Case Files: </strong>
                    </p>
                  </Col>
                </Row>
                <div className="Filecontainer">
                  {testCaseFileList?.length > 0 ? (
                    <span>
                      {testCaseFileList.map((FileArray, index) => {
                        const fileType = FileArray?.filename
                          ?.split(".")
                          .pop()
                          .split("?")[0]
                          .toLowerCase();
                        const isDoc = fileType === "doc" || fileType === "docx";

                        return (
                          <div className="file mx-2 my-4" key={index}>
                            {/* ✅ Common wrapper with relative positioning */}
                            <div
                              style={{
                                position: "relative",
                                display: "inline-block",
                              }}
                            >
                              {Number(data?.status) === 0 && (
                                <IconButton
                                  onClick={() =>
                                    handleRemoveTestCase(item.trackingid, index)
                                  }
                                  style={{
                                    position: "absolute",
                                    top: "0px",
                                    right: "0px",
                                    zIndex: 10,
                                    // backgroundColor: "#fff",
                                    borderRadius: "50%",
                                    padding: "3px",
                                    boxShadow: "0 0 5px rgba(0,0,0,0.2)",
                                  }}
                                >
                                  <HighlightOffIcon
                                    sx={{ fontSize: 18, color: "#d32f2f" }}
                                  />
                                </IconButton>
                              )}

                              {/* 📄 DOC/DOCX Files */}
                              {isDoc ? (
                                <>
                                  <img
                                    src="https://img.icons8.com/color/144/000000/google-docs--v1.png"
                                    width="120px"
                                    height="120px"
                                    alt="doc"
                                  />
                                  <Tooltip title={FileArray?.subname}>
                                    <p
                                      style={{
                                        width: "113px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        margin: "5px 0",
                                        textAlign: "center",
                                        fontSize: "12px",
                                        cursor: "default",
                                      }}
                                    >
                                      {FileArray?.subname}
                                    </p>
                                  </Tooltip>
                                  <IconButton
                                    style={{ width: "100%" }}
                                    onClick={() => {
                                      downloadTUD(
                                        FileArray?.tuddocumentid,
                                        FileArray?.filename,
                                      );
                                    }}
                                  >
                                    <DownloadIcon className="downloadbtn downloadicon" />
                                  </IconButton>
                                </>
                              ) : (
                                /* 🖼️ IMAGE OR OTHER FILES */
                                <>
                                  <div className="image-view-document">
                                    <ModalImage
                                      small={FileArray?.fileurl}
                                      large={FileArray?.fileurl}
                                      hideZoom={false}
                                      showRotate={true}
                                    />
                                  </div>
                                  <p className="filename">
                                    {FileArray?.filename}
                                  </p>
                                  <div className="d-flex justify-content-center align-items-center">
                                    <IconButton
                                      onClick={() => {
                                        downloadTUD(
                                          FileArray?.tuddocumentid,
                                          FileArray?.filename,
                                        );
                                      }}
                                    >
                                      <DownloadIcon className="downloadbtn" />
                                    </IconButton>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </span>
                  ) : null}
                </div>

                <div className="pt-1">
                  <FormWrap>
                    {editPermission && (
                      <div className="">
                        <form
                          id="form-file-upload"
                          onDragEnter={handleDragtestCase}
                          onDragLeave={handleDragtestCase}
                          onDragOver={handleDragtestCase}
                          onDrop={handleTestCaseDrop}
                        >
                          <input
                            ref={testCaseInputRef}
                            type="file"
                            id="input-file-upload"
                            name={name}
                            value={value}
                            onChange={(e) => {
                              handleTestCaseChange(e);
                            }}
                            multiple
                            accept=".doc,.docx"
                          />
                          <label
                            id="label-file-upload"
                            className={testCaseDragActive ? "drag-active" : ""}
                          >
                            <div>
                              <IconButton
                                className="upload-button"
                                onClick={onButtonClickTestCase}
                              >
                                <UploadFileIcon fontSize="large" />
                              </IconButton>
                              <p className="upload-text">
                                Upload Test Case file here
                              </p>
                              <p className="upload-format">
                                Supported formats (Doc)
                              </p>
                            </div>
                          </label>
                          {testCaseDragActive && (
                            <div
                              id="tud-drag-file-element"
                              onDragEnter={handleDragtestCase}
                              onDragLeave={handleDragtestCase}
                              onDragOver={handleDragtestCase}
                              onDrop={handleTestCaseDrop}
                            ></div>
                          )}
                        </form>
                      </div>
                    )}
                    <div>
                      {fileUploadMessageTestCase ? (
                        <Alert className="mt-5" dismissible severity="success">
                          {" "}
                          {fileUploadMessageTestCase}{" "}
                        </Alert>
                      ) : null}
                      <div className="Filecontainer">
                        {selectedTestCaseFile ? (
                          <span>
                            {FileArrayUploadTestCase.slice(0, 10).map(
                              (FileArrayUploadTestCase, index) => {
                                return (
                                  <div className="imgRow mb-2 mt-5">
                                    {FileArrayUploadTestCase[0] == "docx" ||
                                    FileArrayUploadTestCase[0] == "doc" ||
                                    FileArrayUploadTestCase[0] == "DOCX" ||
                                    FileArrayUploadTestCase[0] == "DOC" ? (
                                      <>
                                        <div></div>
                                        <div>
                                          <img
                                            src="https://img.icons8.com/color/144/000000/google-docs--v1.png"
                                            width="113px"
                                            height="110px"
                                            alt="Document"
                                          />
                                          <Tooltip
                                            title={FileArrayUploadTestCase[2]}
                                          >
                                            <p
                                              style={{
                                                width: "113px",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                margin: "5px 0",
                                                textAlign: "center",
                                                fontSize: "12px",
                                                cursor: "default", // Shows hover cursor
                                              }}
                                            >
                                              {FileArrayUploadTestCase[2]}
                                            </p>
                                          </Tooltip>
                                        </div>{" "}
                                      </>
                                    ) : (
                                      <>
                                        <div></div>
                                        <div>
                                          <img
                                            src={FileArrayUploadTestCase[1]}
                                            width="113px"
                                            height="110px"
                                          />
                                          <p className="fileuploadname">
                                            {FileArrayUploadTestCase[2]}
                                          </p>
                                        </div>
                                      </>
                                    )}

                                    <IconButton
                                      className="removebtn "
                                      onClick={() => removeTestCaseImage(index)}
                                    >
                                      <HighlightOffIcon fontSize="small" />
                                    </IconButton>
                                  </div>
                                );
                              },
                            )}
                          </span>
                        ) : null}
                      </div>
                    </div>
                  </FormWrap>
                  {showAddBtnTestCase ? (
                    <>
                      <Button
                        className="btn btn-orange mt-1 float-end"
                        onClick={(e) => {
                          handleUploadFileTestCase(
                            item.trackingid,
                            item?.trackingprojectsid,
                          );
                          // setViewTaskData((prevState) => {
                          //   return { ...prevState, fileurls: fname }
                          // })
                          // setShowEditTask((prevState) => {
                          //   return { ...prevState, editfileurls: false }
                          // })
                          // resetUpload()
                        }}
                        style={{
                          background: fileLoadingTestCase
                            ? "#FFFFFF"
                            : "#4EB6EE",
                          color: fileLoadingTestCase ? "#808080" : "#FFFFFF",
                          border: fileLoadingTestCase
                            ? "2px solid #FFFFFF"
                            : "2px solid #4EB6EE",
                        }}
                      >
                        {fileLoadingTestCase ? (
                          <BarLoader
                            color="#808080"
                            className="bar-loader"
                            size={14}
                            role="status"
                            aria-hidden="true"
                          />
                        ) : (
                          <></>
                        )}
                        Upload TCD{""}
                      </Button>
                    </>
                  ) : null}
                </div>
              </div>
            )}

          {(selected_menu !== "archive" ||
            (selected_menu === "archive" && fileArray?.length > 0)) && (
            <div className="p-2">
              <Row>
                <Col>
                  {" "}
                  <p className="mb-0 mt-3">
                    <strong className="tr-color"> Supported Files: </strong>
                  </p>
                </Col>
              </Row>
              {fileUploadMessage ? (
                <Alert dismissible severity="success">
                  {" "}
                  {fileUploadMessage}{" "}
                </Alert>
              ) : null}

              {fileLoading ? (
                <div className="text-center mt-5 mb-5">
                  <Spinner animation="border" variant="info" />
                </div>
              ) : (
                <>
                  <div className="Filecontainer">
                    {fileArray ? (
                      <span>
                        {fileArray.map((FileArray, index) => {
                          return (
                            <>
                              <div className="file mx-2 my-4">
                                {FileArray[0] == "mp4" ? (
                                  <>
                                    <div></div>
                                    <div>
                                      <video
                                        width="200"
                                        height="120"
                                        className="video"
                                        src={FileArray[1]}
                                        controls
                                      />
                                      <p className="filename videoname">
                                        {FileArray[2]}
                                      </p>
                                      <IconButton
                                        style={{ width: "100%" }}
                                        onClick={() => {
                                          setDownloading(true);
                                          // download(`${FileArray[1]}`, FileArray[2])
                                          downloadFile(
                                            FileArray[1],
                                            FileArray[2],
                                          );
                                        }}
                                      >
                                        {downloading ? (
                                          <progress
                                            id="video"
                                            className="video_inprogress"
                                            value={percentage}
                                            max="100"
                                          />
                                        ) : (
                                          <DownloadIcon className="downloadbtn videodwn" />
                                        )}
                                      </IconButton>
                                    </div>
                                  </>
                                ) : FileArray[0] == "webm" ? (
                                  <>
                                    <div></div>
                                    <div>
                                      <video
                                        width="200"
                                        height="120"
                                        className="video"
                                        src={FileArray[1]}
                                        controls
                                      />
                                      <p className="filename videoname">
                                        {FileArray[2]}
                                      </p>
                                      <IconButton
                                        style={{ width: "100%" }}
                                        onClick={() => {
                                          // download(`${FileArray[1]}`, FileArray[2])
                                          downloadFile(
                                            FileArray[1],
                                            FileArray[2],
                                          );
                                        }}
                                      >
                                        <DownloadIcon className="downloadbtn videodwn" />
                                      </IconButton>
                                    </div>
                                  </>
                                ) : FileArray[0] === "pdf" ||
                                  FileArray[0] === "PDF" ? (
                                  <>
                                    <div></div>
                                    <div>
                                      <img
                                        src="https://img.icons8.com/color/96/000000/pdf-2--v1.png"
                                        width="120px"
                                        height="120px"
                                        alt="pdf"
                                      />
                                      <p className="filename">{FileArray[2]}</p>
                                      <IconButton
                                        style={{ width: "100%" }}
                                        onClick={() => {
                                          // download(`${FileArray[1]}`, FileArray[2])
                                          downloadFile(
                                            FileArray[1],
                                            FileArray[2],
                                          );
                                        }}
                                      >
                                        <DownloadIcon className="downloadbtn" />
                                      </IconButton>
                                    </div>
                                  </>
                                ) : FileArray[0] === "docx" ||
                                  FileArray[0] === "doc" ||
                                  FileArray[0] === "DOCX" ||
                                  FileArray[0] === "DOC" ? (
                                  <>
                                    <div></div>
                                    <div>
                                      <img
                                        src="https://img.icons8.com/color/144/000000/google-docs--v1.png"
                                        width="120px"
                                        height="120px"
                                        alt="doc"
                                      />
                                      <p className="filename">{FileArray[2]}</p>
                                      <IconButton
                                        style={{ width: "100%" }}
                                        onClick={() => {
                                          // download(`${FileArray[1]}`, FileArray[2])
                                          downloadFile(
                                            FileArray[1],
                                            FileArray[2],
                                          );
                                        }}
                                      >
                                        <DownloadIcon className="downloadbtn downloadicon" />
                                      </IconButton>
                                    </div>
                                  </>
                                ) : FileArray[0] === "csv" ||
                                  FileArray[0] === "CSV" ||
                                  FileArray[0] === "xls" ||
                                  FileArray[0] === "xlsx" ||
                                  FileArray[0] === "XLS" ||
                                  FileArray[0] === "XLSX" ? (
                                  <>
                                    <div></div>
                                    <div>
                                      <img
                                        src="https://img.icons8.com/color/144/000000/microsoft-excel-2019--v1.png"
                                        alt="excel"
                                        width="120px"
                                        height="120px"
                                      />
                                      <p className="filename">{FileArray[2]}</p>
                                      <IconButton
                                        style={{ width: "100%" }}
                                        onClick={() => {
                                          // download(`${FileArray[1]}`, FileArray[2])
                                          downloadFile(
                                            FileArray[1],
                                            FileArray[2],
                                          );
                                        }}
                                      >
                                        <DownloadIcon className="downloadbtn downloadicon" />
                                      </IconButton>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <div></div>
                                    <div>
                                      <div className="image-view-document">
                                        <ModalImage
                                          small={FileArray[1]}
                                          large={FileArray[1]}
                                          hideZoom={false}
                                          showRotate={true}
                                        />
                                      </div>
                                      <p className="filename">{FileArray[2]}</p>
                                      <div className="d-flex justify-content-center align-items-center">
                                        <IconButton
                                          onClick={() => {
                                            downloadFile(
                                              FileArray[1],
                                              FileArray[2],
                                            );
                                          }}
                                        >
                                          <DownloadIcon className="downloadbtn" />
                                        </IconButton>
                                        {/* 
                                      <IconButton
                                        onClick={() => {
                                          writeClipImg(FileArray[1])
                                        }}
                                      >
                                        <ContentCopyIcon
                                          sx={{ cursor: "copy" }}
                                          className='downloadbtn videodwn'
                                        />
                                      </IconButton> */}
                                      </div>
                                    </div>
                                  </>
                                )}
                                <IconButton
                                  onClick={() => {
                                    deleteFile(index);
                                    onClickSave();
                                  }}
                                  className="deletebtn"
                                >
                                  <HighlightOffIcon />
                                </IconButton>
                              </div>
                            </>
                          );
                        })}
                      </span>
                    ) : null}
                  </div>
                </>
              )}

              <div className="pt-2">
                <FormWrap>
                  {editPermission && (
                    <div className=" ">
                      <form
                        id="form-file-upload"
                        onDragEnter={handleDrag}
                        onDragLeave={handleDrag}
                        onDragOver={handleDrag}
                        onDrop={handleDrop}
                      >
                        <input
                          ref={inputRef}
                          type="file"
                          id="input-file-upload"
                          name={name}
                          value={value}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          multiple
                          accept="image/*,video/*,.pdf,.mp4,.webm"
                        />
                        <label
                          id="label-file-upload"
                          className={dragActive ? "drag-active" : ""}
                        >
                          <div>
                            <IconButton
                              className="upload-button"
                              onClick={onButtonClick}
                            >
                              <UploadFileIcon fontSize="large" />
                            </IconButton>
                            <p className="upload-text">
                              Drag and drop file here
                            </p>
                            <p className="upload-format">
                              Supported formats (PNG, JPEG, JPG, Mp4, webm, Pdf)
                            </p>
                          </div>
                        </label>
                        {dragActive && (
                          <div
                            id="drag-file-element"
                            onDragEnter={handleDrag}
                            onDragLeave={handleDrag}
                            onDragOver={handleDrag}
                            onDrop={handleDrop}
                          ></div>
                        )}
                      </form>
                    </div>
                  )}
                  <div>
                    {selectedFile ? (
                      <span>
                        {FileArrayUpload.slice(0, 10).map(
                          (FileArrayUpload, index) => {
                            return (
                              <div className="imgRow mb-2 mt-5">
                                {FileArrayUpload[0] == "mp4" ? (
                                  <>
                                    <div></div>
                                    <div>
                                      <video
                                        url={FileArrayUpload[1]}
                                        height="112px"
                                        width="200px"
                                        allowFullScreen
                                      />
                                      <p className="fileuploadname">
                                        {FileArrayUpload[2]}
                                      </p>
                                    </div>{" "}
                                  </>
                                ) : FileArrayUpload[0] == "webm" ? (
                                  <>
                                    <div></div>
                                    <div>
                                      <Iframe
                                        url={FileArrayUpload[1]}
                                        height="112px"
                                        width="200px"
                                        allowFullScreen
                                      />
                                      <p className="fileuploadname">
                                        {FileArrayUpload[2]}
                                      </p>
                                    </div>{" "}
                                  </>
                                ) : FileArrayUpload[0] == "pdf" ||
                                  FileArrayUpload[0] == "PDF" ? (
                                  <>
                                    <div></div>
                                    <div>
                                      <img
                                        src="https://img.icons8.com/color/96/000000/pdf-2--v1.png"
                                        width="113px"
                                        height="110px"
                                        alt="pdf"
                                      />
                                      <p className="fileuploadname">
                                        {FileArrayUpload[2]}
                                      </p>
                                    </div>
                                  </>
                                ) : FileArrayUpload[0] == "docx" ||
                                  FileArrayUpload[0] == "doc" ||
                                  FileArrayUpload[0] == "DOCX" ||
                                  FileArrayUpload[0] == "DOC" ? (
                                  <>
                                    <div></div>
                                    <div>
                                      <img
                                        src="https://img.icons8.com/color/144/000000/google-docs--v1.png"
                                        width="113px"
                                        height="110px"
                                        alt="Document"
                                      />
                                      <p className="fileuploadname">
                                        {FileArrayUpload[2]}
                                      </p>
                                    </div>{" "}
                                  </>
                                ) : FileArrayUpload[0] == "csv" ||
                                  FileArrayUpload[0] == "CSV" ||
                                  FileArrayUpload[0] == "xls" ||
                                  FileArrayUpload[0] == "xlsx" ||
                                  FileArrayUpload[0] == "XLS" ||
                                  FileArrayUpload[0] == "XLSX" ? (
                                  <>
                                    <div></div>
                                    <div>
                                      <img
                                        src="https://img.icons8.com/color/144/000000/microsoft-excel-2019--v1.png"
                                        width="113px"
                                        height="110px"
                                        alt="Csv file"
                                      />
                                      <p className="fileuploadname">
                                        {FileArrayUpload[2]}
                                      </p>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <div></div>
                                    <div>
                                      <img
                                        src={FileArrayUpload[1]}
                                        width="113px"
                                        height="110px"
                                      />
                                      <p className="fileuploadname">
                                        {FileArrayUpload[2]}
                                      </p>
                                    </div>
                                  </>
                                )}

                                <IconButton
                                  className="removebtn "
                                  onClick={() => removeImage(index)}
                                >
                                  <HighlightOffIcon fontSize="small" />
                                </IconButton>
                              </div>
                            );
                          },
                        )}
                      </span>
                    ) : null}
                  </div>
                </FormWrap>
                {showAddBtn ? (
                  <>
                    <Button
                      className="btn btn-orange mt-5 float-end"
                      onClick={(e) => {
                        handleUploadFile(item.trackingid);
                        setViewTaskData((prevState) => {
                          return { ...prevState, fileurls: fname };
                        });
                        setShowEditTask((prevState) => {
                          return { ...prevState, editfileurls: false };
                        });
                        resetUpload();
                      }}
                      style={{
                        background: fileloading ? "#FFFFFF" : "#4EB6EE",
                        color: fileloading ? "#808080" : "#FFFFFF",
                        border: fileloading
                          ? "2px solid #FFFFFF"
                          : "2px solid #4EB6EE",
                      }}
                    >
                      {fileloading ? (
                        <BarLoader
                          color="#808080"
                          className="bar-loader"
                          size={14}
                          role="status"
                          aria-hidden="true"
                        />
                      ) : (
                        <></>
                      )}
                      Upload{""}
                    </Button>
                  </>
                ) : null}

                {showSaveBtn ? (
                  <Button
                    className="savechangesbtn btn-orange mt-5"
                    onClick={() => {
                      ConfirmDeleteFile();
                      updateTask("fileurls", updatedData.fileurls);
                      updateTask("filesize", updatedData.taskfilesize);
                    }}
                  >
                    Save Changes
                  </Button>
                ) : null}
              </div>
            </div>
          )}
          {/* <br></br>
          <div className='kpy_points_container'>
            <p className='kpy_points_header'>KPI Points:</p>
            <div className='kpy_points_points_name'>
              <div className='kpy_points_status'>
                <div className='kpy_points_status_title'>
                  <p>1. Code review</p>
                </div>
                <Form.Check
                  aria-label="radio 1"
                  label="Passed"
                  name="status"
                  type="radio"
                  className='kpi_points_radio'
                />
                <Form.Check
                  aria-label="radio 2"
                  label="Failed"
                  name="status"
                  type="radio"
                  className='kpi_points_radio'
                />
                <Form.Check
                  aria-label="radio 3"
                  label="Partial"
                  name="status"
                  type="radio"
                  className='kpi_points_radio'
                />
              </div>
              <div className='kpy_points_status'>
                <div className='kpy_points_status_title'>
                  <p>2. Communication</p>
                </div>
                <Form.Check
                  aria-label="radio 1"
                  label="Passed"
                  name="Communication"
                  type="radio"
                  className='kpi_points_radio'
                />
                <Form.Check
                  aria-label="radio 2"
                  label="Failed"
                  name="Communication"
                  type="radio"
                  className='kpi_points_radio'
                />
                <Form.Check
                  aria-label="radio 3"
                  label="Partial"
                  name="Communication"
                  type="radio"
                  className='kpi_points_radio'
                />
              </div>
              <div className='kpy_points_status'>
                <div className='kpy_points_status_title'>
                  <p>3. Deadline</p>
                </div>
                <Form.Check
                  aria-label="radio 1"
                  label="Passed"
                  name="Deadline"
                  type="radio"
                  className='kpi_points_radio'
                />
                <Form.Check
                  aria-label="radio 2"
                  label="Failed"
                  name="Deadline"
                  type="radio"
                  className='kpi_points_radio'
                />
                <Form.Check
                  aria-label="radio 3"
                  label="Partial"
                  name="Deadline"
                  type="radio"
                  className='kpi_points_radio'
                />
              </div>
            </div>
          </div> */}
          {
            <Activity
              item={item}
              history={history ? history : item.history}
              data={data}
            />
          }
        </div>
      </TrackingModalView>
      <UIModal
        showModal={showAddBacklogstModal}
        setShowModal={setShowAddBacklogsModal}
        size="md"
        forBacklogsModel={forBacklogsModel}
        // className="backlogs_move_model"
      >
        <div className="text-center">
          <p className="mb-4 backlogs_move_content">
            This task will move into Backlog items, Not consider to ready
            <br></br> to start at the moment, Kindly refine your backlog task
            <br></br> whenever you get free time
          </p>
          <button
            className="backlogs_go_btn"
            onClick={() => {
              const event = { target: { name: "backlogs", value: "Yes" } };
              onRadiobtnHandler(event);
              fetchViewBacklogssList(moveTrackingId);
              setShowAddBacklogsModal(!showAddBacklogstModal);
              // setddBacklogsSelect(true)
            }}
          >
            Go
          </button>
        </div>
      </UIModal>

      <UIModal
        showModal={flagModal}
        setShowModal={setFlagModal}
        size="md"
        // forBacklogsModel={}
        // className="backlogs_move_model"
      >
        <Form>
          <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
            <Form.Label>Reason:</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              onChange={(e) => setFlagDescription(e.target.value)}
            />
          </Form.Group>
          <div className="flex justify-end gap-2">
            <Button onClick={() => setFlagModal(false)}>Cancel</Button>
            <Button onClick={() => updateTask("raiseflag", data.raiseflag)}>
              Submit
            </Button>
          </div>
        </Form>
      </UIModal>
    </TrackingViewWrap>
  );
};
